import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Container, ButtonGroup } from "react-bootstrap";
// import Modal from "react-bootstrap/Modal";
import "../../App.css";
import "../MortgageCalculators/RateQuote.css";
import * as com from "../../Common.js";
import NumericalInput, {CommaizedInput} from "../../NumericalInput";
import { withRouter } from "react-router-dom";
import IneligibleProductsModal from "../MortgageCalculators/IneligibleProducts";
import AllRatesModal, { AllRatesTable } from "../MortgageCalculators/AllRatesRedesign";
import ReportIssuesModal from "../MortgageCalculators/ReportIssues";
import { YellowWarning } from "../../Common/Warnings";
import {Radio, Skeleton, Select, Input, InputNumber, Switch, Checkbox, Popover, Popconfirm, Spin, Modal, Row, Col, Slider, Dropdown, Tooltip, Table, AutoComplete, message} from "antd";
import { QuestionCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { isMobile } from "react-device-detect";
import { checkAccess } from "../../Auth";
import { UR_PriceEngineUser, UR_LoanOfficer, UR_Owner } from "../../State";
import AutoProgress from '../../DocumentChecklist/AutoProgress';
import { CaretRightOutlined } from '@ant-design/icons';
import Lenders from "../../Management/Lenders";
import AddressAutocomplete from "../../Common/AddressAutocomplete";
// import mockData from "./response_sample.json"
import ClosingCost from "../../Management/estimatedclosingfee/components/ClosingCost";
import LodestarTipsCard from "../../Management/estimatedclosingfee/components/LodestarTipsCard";
import {
  CREDIT_SCORE_MAX,
  CREDIT_SCORE_MIN,
  parsePpeResponse,
  ppePricingUrl,
  ppeAuthHeaders,
} from "./config";
import { noArmProductsMessage } from "./armTerms";
const DEFAULT_LOAN_TERM = 30; //year
const mobileHomeLenders = ["Triad", "CreditHuman"]

// 添加防抖函数
const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
};

const tenK_qualifiedCounties = {
  "North Carolina": [
    "Alexander",
    "Ashe",
    "Avery",
    "Beaufort",
    "Bladen",
    "Brunswick",
    "Buncombe",
    "Burke",
    "Cabarrus",
    "Caldwell",
    "Carteret",
    "Catawba",
    "Chatham",
    "Cherokee",
    "Clay",
    "Columbus",
    "Craven",
    "Cumberland",
    "Duplin",
    "Durham",
    "Forsyth",
    "Franklin",
    "Graham",
    "Greene",
    "Guilford",
    "Halifax",
    "Harnett",
    "Haywood",
    "Henderson",
    "Iredell",
    "Jackson",
    "Johnston",
    "Lee",
    "Lenoir",
    "Lincoln",
    "Macon",
    "Madison",
    "Martin",
    "McDowell",
    "Mecklenburg",
    "Moore",
    "Nash",
    "New Hanover",
    "Onslow",
    "Orange",
    "Pamlico",
    "Pasquotank",
    "Pender",
    "Pitt",
    "Polk",
    "Randolph",
    "Rockingham",
    "Rutherford",
    "Sampson",
    "Stanly",
    "Stokes",
    "Surry",
    "Swain",
    "Transylvania",
    "Union",
    "Vance",
    "Wake",
    "Warren",
    "Watauga",
    "Wayne",
    "Wilkes",
    "Wilson",
    "Yadkin",
    "Yancey",
  ],
  "South Carolina": [
    "Abbeville",
    "Aiken",
    "Anderson",
    "Barnwell",
    "Beaufort",
    "Berkeley",
    "Charleston",
    "Chester",
    "Chesterfield",
    "Clarendon",
    "Darlington",
    "Dillon",
    "Dorchester",
    "Edgefield",
    "Fairfield",
    "Florence",
    "Georgetown",
    "Greenville",
    "Greenwood",
    "Hampton",
    "Horry",
    "Kershaw",
    "Lancaster",
    "Laurens",
    "Lee",
    "Lexington",
    "Marion",
    "Marlboro",
    "McCormick",
    "Newberry",
    "Oconee",
    "Orangeburg",
    "Pickens",
    "Richland",
    "Saluda",
    "Spartanburg",
    "Sumter",
    "Williamsburg",
    "York",
  ],
  Georgia: [
    "Chatham",
    "Cherokee",
    "Cobb",
    "Columbia",
    "De Kalb",
    "Forsyth",
    "Franklin",
    "Fulton",
    "Gwinnett",
    "Hall",
    "Hart",
    "Madison",
    "McDuffie",
    "Pickens",
    "Richmond",
    "Stephens",

  ],
};
const thirtyK_qualifiedCounties = {
  Massachusetts: ["Essex", "Middlesex", "Norfolk", "Suffolk"],
  California: [
    "Contra Costa",
    "Los Angeles",
    "Napa",
    "Orange",
    "Placer",
    "Riverside",
    "Sacramento",
    "San Bernardino",
    "San Diego",
    "San Francisco",
    "San Mateo",
    "Santa Clara",
    "Ventura",
  ],
};
const fiveK_qualifiedCounties = {
};

const zeroDown_qualifiedCounties = {
  California: [
    "San Francisco",
    "San Mateo",
    "Santa Clara",
    "Sacramento",
    "Contra Costa",
    "Los Angeles",
    "Orange",
    "Riverside",
    "San Bernardino",
    "San Diego",
    "Placer",
    "Napa",
    "Ventura",
  ],
  Georgia: [
    "Chatham",
    "Cherokee",
    "Cobb",
    "Columbia",
    "DeKalb",
    "Forsyth",
    "Franklin",
    "Fulton",
    "Gwinnett",
    "Hall",
    "Hart",
    "Madison",
    "McDuffie",
    "Pickens",
    "Richmond",
    "Stephens",
  ],
  Massachusetts: ["Essex", "Middlesex", "Norfolk", "Suffolk"],
  "North Carolina": [
    "Alexander",
    "Ashe",
    "Avery",
    "Beaufort",
    "Bladen",
    "Brunswick",
    "Buncombe",
    "Burke",
    "Cabarrus",
    "Caldwell",
    "Carteret",
    "Catawba",
    "Chatham",
    "Cherokee",
    "Clay",
    "Columbus",
    "Craven",
    "Cumberland",
    "Duplin",
    "Durham",
    "Forsyth",
    "Franklin",
    "Graham",
    "Greene",
    "Guilford",
    "Halifax",
    "Harnett",
    "Haywood",
    "Henderson",
    "Iredell",
    "Jackson",
    "Johnston",
    "Lee",
    "Lenoir",
    "Lincoln",
    "McDowell",
    "Macon",
    "Madison",
    "Martin",
    "Mecklenburg",
    "Mitchell",
    "Montgomery",
    "Moore",
    "Nash",
    "New Hanover",
    "Onslow",
    "Orange",
    "Pamlico",
    "Pasquotank",
    "Pender",
    "Pitt",
    "Polk",
    "Randolph",
    "Richmond",
    "Robeson",
    "Rockingham",
    "Rowan",
    "Rutherford",
    "Sampson",
    "Stanly",
    "Stokes",
    "Surry",
    "Swain",
    "Transylvania",
    "Tyrrell",
    "Union",
    "Vance",
    "Wake",
    "Warren",
    "Washington",
    "Watauga",
    "Wayne",
    "Wilkes",
    "Wilson",
    "Yadkin",
    "Yancey",
  ],
  "South Carolina": [
    "Abbeville",
    "Aiken",
    "Anderson",
    "Barnwell",
    "Beaufort",
    "Berkeley",
    "Charleston",
    "Cherokee",
    "Chester",
    "Chesterfield",
    "Clarendon",
    "Darlington",
    "Dillon",
    "Dorchester",
    "Edgefield",
    "Fairfield",
    "Florence",
    "Georgetown",
    "Greenville",
    "Greenwood",
    "Horry",
    "Kershaw",
    "Lancaster",
    "Laurens",
    "Lee",
    "Lexington",
    "Marion",
    "Marlboro",
    "McCormick",
    "Newberry",
    "Oconee",
    "Orangeburg",
    "Pickens",
    "Richland",
    "Saluda",
    "Spartanburg",
    "Sumter",
    "Union",
    "Williamsburg",
    "York",
  ],
  Virginia: [
    "Albermarle",
    "Alleghany",
    "Arlington",
    "Augusta",
    "Bedford",
    "Botetourt",
    "Brunswick",
    "Campbell",
    "Carroll",
    "Charlottesville City",
    "Chesterfield",
    "Covington City",
    "Danville City",
    "Emporia City",
    "Fairfax",
    "Fairfax City",
    "Frederick",
    "Fredericksburg City",
    "Galax City",
    "Greensville",
    "Harrisonburg City",
    "Henrico",
    "Loudoun",
    "Lunenburg",
    "Lynchburg City",
    "Mecklenburg",
    "Montgomery",
    "Nottoway",
    "Pittsylvania",
    "Roanoke",
    "Roanoke City",
    "Rockingham",
    "Salem City",
    "Spotsylvania",
    "Staunton City",
    "Warren",
    "Waynesboro City",
    "Winchester City",
  ],
};

const craSpecial_qualifiedCounties = {
  "North Carolina": ["Franklin", "Johnston", "Wake","Chatham", "Durham", "Orange", "New Hanover", "Cabarrus", "Mecklenburg","Union", "Moore"],
  "South Carolina": ["Beaufort", "York", "Berkeley", "Charleston", "Dorchester"],
}

const mapSpecialAdjustments = {
  LMIB: -0.125,
  LMIT: -0.125,
  MMCT_10K: -0.375,
  MMCT_30K: -0.125,
  CRA_10K: -0.5,
  CRA_30K: -0.75,
}

const RateQuoteLOVersion = (props) => {
  const {
    onLendersChange,
    // ... existing code ...
  } = props;
  let customerid = com.getCustomerId();
  
  const [specialAdjustments, setSpecialAdjustments] = useState({});
  const [selectedLenders, setSelectedLenders] = useState([]);
  const [loanTerm,setLoanTerm] = useState("fixed30");
  const [productTypes, setProductTypes] = useState(["Agency", "Jumbo", "FHA"]);
  const [showForm, setShowForm] = useState(true);
  const [useDiscountFormat, setUseDiscountFormat] = useState(false);
  const [showConnectedLendersOnly, setShowConnectedLendersOnly] = useState(true);
  const [eligibilityView, setEligibilityView] = useState("eligible");
  const [pointFormat, setPointFormat] = useState(true);
  const [targetPriceDollar, setTargetPriceDollar] = useState(3000);
  const [targetPricePoint, setTargetPricePoint] = useState(100); //for zeitro set compensation as 1.75, for generate client use 100
  const [targetRate, setTargetRate] = useState(1);
  const [calcOptions, setCalcOptions] = useState(["lockpoint", "adjustment", "compensation"]);
  const [resultlenderSet, setResultlenderSet] = useState(new Set());
  const [formContainerHeight, setFormContainerHeight] = useState(0);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [extended, setExtended] = useState(true);
  const [stdproducts,setStdProducts] = useState([
    {label:"Agency",value: "Agency"},
    {label:"Jumbo",value: "Jumbo"},
    {label:"FHA",value: "FHA"},
    {label:"VA",value: "VA"},
  ]);
  const [assets, setAssets] = useState("fullassets");
  const [incomeCondition, setIncomeCondition] = useState("fullincome");
  const [employment,setEmployment] = useState("Employed");
  const [emptydti,setEmptyDTI] = useState(false);
  const [emptymonthlyIncome,setEmptymonthlyIncome] = useState(false);
  const [notmodified,setNotmodified] = useState(false);
  const [loanLimits, setLoanLimits] = useState({});
  const [emptyLtv, setEmptyLtv] = useState(false)
  const [emptyDownpay,setEmptyDownpay] = useState(false)
  const [emptyPropertyVal,setEmptyPropertyVal] = useState(false)
  const [propertyType, setPropertyType] = useState("singlefamilydetached");
  const [propertyValue, setPropertyValue] = useState(500000);
  const [purpose, setPurpose] = useState("Purchase");
  const [occupancy, onOccupancy] = useState("principal");
  const [validated, setValidated] = useState(false);
  const [downpayment, setDownpayment] = useState(100000);
  const [county, setCounty] = useState("ALAMEDA COUNTY");
  const [state, setState] = useState("CALIFORNIA");
  const [dti, setDTI] = useState(10);
  const [monthlyIncome, setMonthlyIncome] = useState(10000);
  const [monthlyDebt, setMonthlyDebt] = useState(3000);
  const [estOtherCosts, setEstOtherCosts] = useState(0);
  const [isCalculatedAtResults, setIsCalculatedAtResults] = useState(false);
  const [units, setUnits] = useState(2);
  const [loading, setLoading] = useState(false);
  const [loans, setLoans] = useState([]);
  const [fico, setFico] = useState(780);
  const [lockDay, setLockDay] = useState(30);
  const [citizenship, setCitizenship] = useState("US_CITIZENS");
  const [visaType, setVisaType] = useState("H_1B");
  const [numberOfOwnedProperties, setNumberOfOwnedProperties] = useState(1);
  const [currentJobInMonths, setCurrentJobInMonths] = useState(24);
  const [secondMortageAmount, setSecondMortgageAmount] = useState(0);
  const [escrowWaiver, setEscrowWaiver] = useState(false)
  const [selfEmployed, setSelfEmployed] = useState(false)
  const [rentalIncomeUsed, setRentalIncomeUsed] = useState(false)
  const [firstTimeHomeBuyer, setfirstTimeHomeBuyer] = useState("Yes")
  const [appraisalWaiver, setAppraisalWaiver] = useState(false)
  const [rsuAsIncome, setRsuAsIncome] = useState(false)
  const [giftFundUsed, setGiftFundUsed] = useState(false)
  const [workForSpecialBusiness, setWorkForSpecialBusiness] = useState(false)
  const [nonOccupancyCoBorrower, setNonOccupancyCoBorrower] = useState(false)
  const [borrowerPaidCompensation, setBorrowerPaidCompensation] = useState(false)
  const [borrowerPaidCompensationAmount, setBorrowerPaidCompensationAmount] = useState(0)
  
  const [indexfixed30, setIndexFixed30] = useState(8);
  const [indexfixed25, setIndexFixed25] = useState(6);
  const [indexfixed20, setIndexFixed20] = useState(6);
  const [indexfixed15, setIndexFixed15] = useState(6);
  const [indexfixed10, setIndexFixed10] = useState(6);
  const [indexarm56, setIndexArm56] = useState(6);
  const [indexarm76, setIndexArm76] = useState(6);
  const [indexarm106, setIndexArm106] = useState(6);
  const [ineligibleProducts, setIneligibleProducts] = useState({});
  const [showIneligible, setShowIneligible] = useState(false);
  const [noProducts, setNoProducts] = useState(false);
  const [allRates, setAllRates] = useState({});
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const pricingRequestIdRef = useRef(0);
  const [showReportIssues, setShowReportIssues] = useState(false);
  const [showRatePreview, setShowRatePreview] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [loProfile, setLOProfile] = useState({});

  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const [showFileModal, setShowFileModel] = useState(false);
  const handleCloseFileModal = () => setShowFileModel(false);
  const handleShowFileModal = () => setShowFileModel(true);
  const [showAddLenderModal, setShowAddLendersModal] = useState(false);

  const [showEditCostDetails, setShowEditCostDetails] = useState(false);
  const [address, setAddress] = useState("");
  const [displayedAddress, setDisplayedAddress] = useState("");
  const [zip, setZip] = useState("");
  const [city, setCity] = useState("");
  const [celebrityCounty, setCelebrityCounty] = useState("");
  const [celebrityState, setCelebrityState] = useState("");
  const [celebrityAddress, setCelebrityAddress] = useState("");
  const [loadingTractData, setLoadingTractData] = useState(false);
  const [showUnavailable, setShowUnavailable] = useState(false);
  const [skipCRA, setSkipCRA] = useState(true);
  const [medianIncome, setMedianIncome] = useState(0);
  const [incomeIndicator, setIncomeIndicator] = useState("");
  const [minority, setMinority] = useState(0);
  const [mfi, setMfi] = useState(0);
  const [applyLMIB, setApplyLMIB] = useState(false);
  const [applyLMIT, setApplyLMIT] = useState(false);
  const [applyMMCT, setApplyMMCT] = useState(false);
  const [totalPopulation, setTotalPopulation] = useState(0);
  const [hispanic, setHispanic] = useState(0);
  const [black, setBlack] = useState(0);
  const [asian, setAsian] = useState(0);
  const [pacific, setPacific] = useState(0);
  const [msaCode, setMsaCode] = useState(0);
  const [applyExtraCRA, setApplyExtraCRA] = useState(false);
  const handleEditCostDetailsModal = () => setShowEditCostDetails(false);
  const [cannotshop, setCannotshop] = useState([])
  const [canshop, setCanshop] = useState([])
  const [cannotshopOptions, setCannotshopOptions] = useState([])
  const [canshopOptions, setCanshopOptions] = useState([])
  const [connectedLendersMap, setConnectedLendersMap] = useState({});
  const [openLender, setOpenLender] = useState(false)
  const [lenderData, setLenderData] = useState([])
  const [lodeStarConfig, setLodeStarConfig] = useState({
    "suggestEnableCount": 1,
    "isModified": false,
    "enableOriginationCharges": true,
    "enableCanNotShopServices": true,
    "enableCanShopServices": true,
    "enableTaxesAndOtherGovernmentFees": true,
    "enablePrepaids": true,
    "enableInitialEscrowPaymentsAtClosing": true,
    "enableOther": true
})
const closingCostRef = useRef()
const [totalClosingFee, setTotalClosingFee] = useState(0)
const [closingFeeConfig, setClosingFeeConfig] = useState({
  originationCharges: null,
  canNotShopServices: null,
  canShopServices: null,
  taxesAndOtherGovernmentFees: null,
  prepaids: null,
  initialEscrowPaymentsAtClosing: null,
  other: null,
})

const [appliedClosingCostsDetail, setAppliedClosingCostsDetail] = useState({})
const [loanType, setLoanType] = useState("")
  const specificProgram = props.specificProgram

  let getHeight = () => {
    if (checkAccess([UR_PriceEngineUser])) {
      return viewportHeight-52
    }
    return viewportHeight - 85
  }

  let targetPriceOptions = [
    { label: "Lock point", value: "lockpoint" },
    { label: "Adjustment", value: "adjustment" },
    { label: "Compensation", value: "compensation" },

  ];
  let preselectedTermOptions = [
    { name: "Fixed 30 Yr", key: "fixed30" },
    { name: "Fixed 15 Yr", key: "fixed15" },
    { name: "ARM 5 Year", key: "arm56" },
  ];

  let productTypesMap = {
    Agency: ["CONFORMING", "SUPER_CONFORMING"],
    Jumbo: ["JUMBO"],
    FHA: ["FHA", "FHA_HIGH_BALANCE"],
    VA: ["VA", "VA_HIGH_BALANCE"],
  }

  let fileSuffixMap = {
    Fairway: "pdf",
    HomePoint: "xlsx",
    PRMG: "xlsx",
    AmeriHome: "xlsx",
    HomePointDelegated: "xlsx",
    FifthThirdBank: "xls",
    RocketPro: "xlsx",
    USBank: "pdf",
    PRMG: "xls",
    Caliber: "pdf",
    LoanDepot: "pdf",
    Amwest: "pdf",
    DivineMortgage: "pdf",
    LoanStore: "pdf",
    NewWaveLending: "pdf",
    WholesaleMortgageLender: "pdf",
    ResiCentral: "pdf",
    Provident: "csv",
    GMCCCelebrities : "xlsx",
    FlagStar : "xlsx",
    PlanetHome : "xlsx",
  };

  const TYPE_MAP = {
    Purchase: "Purchase",
    RateTermRefi: "Refinance",
    CashOutRefi: "Cashout"
  }

const handleParamsChange = (searchParams) => {
      // console.log('-------', searchParams, searchParams.purpose, searchParams.downPayment, searchParams.propertyValue)
      if (parseInt(searchParams.downPayment) >= parseInt(searchParams.propertyValue)) {
        setValidated(true);
        const mapLabel = {
          "Purchase": "Down payment",
          "RateTermRefi": "Loan amount",
          "CashOutRefi": "Loan amount"
        }
        alert(`${mapLabel[searchParams.purpose]} can't be bigger than ${searchParams.purpose === "Purchase" ? "property value" : "home value"}` );
        return;
      }
      const searchFico = parseInt(searchParams.FICO ?? searchParams.fico);
      if (!Number.isFinite(searchFico) || searchFico < CREDIT_SCORE_MIN || searchFico > CREDIT_SCORE_MAX) {
        setValidated(true);
        alert(`FICO score should be in the range of ${CREDIT_SCORE_MIN} - ${CREDIT_SCORE_MAX}`);
        return;
      }
      // setNotmodified(false);
      setShowForm(false);
      getProducts();
      setExtended(false)
}
// const debouncedGetProducts = useRef(
//     debounce(() => {
//         getProducts();
//     }, 500)
// ).current;

  useEffect(() => {
    if(!props.searchParams.propertyValue){
      // console.log('in result table ----- loan amount equal 0')
    }else{
      // console.log("in result table ----- props.searchParams", props.searchParams)
      setLockDay(Number(props.searchParams.lockDay) || 30)
      setDownpayment(props.searchParams.downPayment || 0)
      setLoanTerm(props.searchParams.loanTerms)
      setLoanType(props.searchParams.loanType)
      setSelectedLenders(props.searchParams.selectedLenders || [])
      setTargetPricePoint(props.searchParams.targetPrice || 0)
      setTargetRate(Number(props.searchParams.targetRate || 0 ))
      handleParamsChange(props.searchParams);
    }
    //   debouncedGetProducts();
  }, [props.searchParams])

  // useEffect(() => {
    // setLoanType(props.loanTypeFilter);
    // handleParamsChange(props.searchParams, false);
  // }, [props.loanTypeFilter])

  useEffect(() => {
    measureFormContainerHeight();

    window.addEventListener("resize", measureFormContainerHeight);

    return () => {
      window.removeEventListener("resize", measureFormContainerHeight);
    }
  },[]);

  useEffect(() => {
    // console.log('props.search--------', props.search);
    if (props.search) {
      getProducts();
    }
  }, [props.search]);

  useEffect(() => {
    // Function to update viewport height when the window is resized
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
      setViewportWidth(window.innerWidth)
    };

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // (removed: legacy manufactured-home restriction that forced fixed25 --
  // eligibility for 30-year manufactured products is decided by lender rules)

  const [selectedTerms, setSelectedTerms] = useState(preselectedTermOptions);
  const underwritingOptions = [
    { label: "DU", value: "DU" },
    { label: "LP", value: "LP" },
    { label: "Manual", value: "Manual" },
  ];
  const [selectedAUS, setSelectedAUS] = useState(underwritingOptions);

  const form = useRef();

  let getLtv = () => {
    let ltv = Number(((getLoanAmount() / parseInt(propertyValue)) * 100).toFixed(1));
    let cltv = Number(((getLoanAmount() + parseInt(secondMortageAmount)) / parseInt(propertyValue) * 100).toFixed(1));
    let hcltv = Number(((getLoanAmount() + parseInt(secondMortageAmount)) / parseInt(propertyValue) * 100).toFixed(1));
    return [ltv, cltv, hcltv];
  };

  const getPositiveAmount = (...values) => values
    .map(Number)
    .find(value => Number.isFinite(value) && value > 0);

  let getLoanAmount = () => {
    const pricingRequest = props.searchParams.pricingRequest || {};
    const loanProgram = String(
      pricingRequest.loanProgram || props.searchParams.loanProgram || ''
    ).toLowerCase();

    // HELOC may use Purchase as the purpose, but its points are priced against
    // the active draw/base amount, not property value minus down payment.
    if (loanProgram === 'heloc') {
      return getPositiveAmount(
        pricingRequest.drawAmount,
        props.searchParams.drawAmount,
        pricingRequest.baseLoanAmount,
        props.searchParams.baseLoanAmount,
        pricingRequest.lineAmount,
        props.searchParams.lineAmount,
        props.searchParams.loanAmount
      ) || 0;
    }

    if (props.searchParams.purpose === "Purchase") {
      return Number(props.searchParams.propertyValue) - Number(props.searchParams.downPayment);
    }

    // Refinance requests do not have a down payment. Their subject loan amount
    // is carried by the legacy UI field and by the clean PPE request body.
    return Number(
      props.searchParams.loanAmount ??
      props.searchParams.baseLoanAmount ??
      props.searchParams.pricingRequest?.baseLoanAmount
    );
  };

  let checkGrantEligibility = () => {
    if (loanTerm !=="fixed30" && purpose !== "Purchase" && occupancy==="principal") {
       return "None"
    }

    if((tenK_qualifiedCounties[celebrityState] !== undefined && (tenK_qualifiedCounties[celebrityState].length===0|| tenK_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim()))) && 
    (monthlyIncome*12 <= mfi*1.5 || (monthlyIncome*12 <= mfi*2 && firstTimeHomeBuyer)) && 
    (minority>50 || incomeIndicator === 1 || incomeIndicator === 2) &&
    fico >=620 && getLoanAmount()>=25000 && getLoanAmount()<=832750 && getLtv()[0]>=75
  ){
        return "10K"
    }
    else if ( (fiveK_qualifiedCounties[celebrityState] !== undefined && (fiveK_qualifiedCounties[celebrityState].length===0|| fiveK_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim()))) && 
    (monthlyIncome*12 <= mfi*1.5 || (monthlyIncome*12 <= mfi*2 && firstTimeHomeBuyer)) && 
    (minority>50 || incomeIndicator === 1 || incomeIndicator === 2) &&
    fico >=620 && getLoanAmount()>=25000 && getLoanAmount()<=832750 && getLtv()[0]>=80
  ){
      return "10K"
    }
    else if((thirtyK_qualifiedCounties[celebrityState] !== undefined && (thirtyK_qualifiedCounties[celebrityState].length===0|| thirtyK_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim()))) && 
    (monthlyIncome*12 <= mfi*1.5 || (monthlyIncome*12 <= mfi*2 && firstTimeHomeBuyer)) && 
    (minority>50 || incomeIndicator === 1 || incomeIndicator === 2) &&
    fico >=620 && getLoanAmount()>=25000 && getLoanAmount()<=832750 && getLtv()[0]>=80
  ){
      return "10K"
    }
    else if((zeroDown_qualifiedCounties[celebrityState] !== undefined && (zeroDown_qualifiedCounties[celebrityState].length===0|| zeroDown_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim()))) && 
    (monthlyIncome*12 <= mfi*1.5 || (monthlyIncome*12 <= mfi*2 && firstTimeHomeBuyer)) && 
    (minority>50 || incomeIndicator === 1 || incomeIndicator === 2) &&
    fico >=620 && getLoanAmount()>=25000 && getLoanAmount()<=832750 && getLtv()[0]>=80
  ){
      return "10K"
    }
    else{
      return "None"
    }
  }

  let checkCelebrityLendingArea = () => {
    if (skipCRA){
      let parsedState = com.capitalize(state)
      let parsedCounty = com.capitalize(county)
      if ( (zeroDown_qualifiedCounties[parsedState] !== undefined && (zeroDown_qualifiedCounties[parsedState].length===0|| zeroDown_qualifiedCounties[parsedState].includes(parsedCounty.replace("County", "").trim())))){
        return true
      } else {
        return false
      }
    }
    if (showUnavailable){
      let parsedState = com.capitalize(state)
      let parsedCounty = com.capitalize(county)
      if ( (zeroDown_qualifiedCounties[parsedState] !== undefined && (zeroDown_qualifiedCounties[parsedState].length===0|| zeroDown_qualifiedCounties[parsedState].includes(parsedCounty.replace("County", "").trim())))){
        return true
      } else {
        return false
      }
    } else {
      if ( (zeroDown_qualifiedCounties[celebrityState] !== undefined && (zeroDown_qualifiedCounties[celebrityState].length===0|| zeroDown_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim())))){
        return true
      }
      else{
        return false
      }
    }
  }

  let downloadRatesheet = (loan) => {
    let s2ab = (s) => {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };

    let blob = new Blob([s2ab(atob(loan.FileB))], { type: "" });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    if (fileSuffixMap[loan.Lender] == undefined) {
      handleShowFileModal();
      return;
    }

    link.download = loan.Lender + "_Ratesheet." + fileSuffixMap[loan.Lender];
    link.click();
  };


  let handleEditCostDetails = () => {
    if (showEditCostDetails) {
      setShowEditCostDetails(false);
    } else {
      setShowEditCostDetails(true);
    }
  };

  let getProducts = () => {
    if(!props.searchParams.propertyValue) return;
    const requestId = ++pricingRequestIdRef.current;
    let pmi = 0.51;
    let zeitro_fee = [{ lender: "default", percent: 1.0, fixed: 500 }];
    let _units = 1;
    let _county = "ZAVALA COUNTY";
    if (propertyType === "twotofourfamily") _units = units;


    let arm56 = [];
    let arm31 = [];
    let arm76 = [];
    let arm106 = [];
    let fixed40 = [];
    let fixed30 = [];
    let fixed25 = [];
    let fixed20 = [];
    let fixed15 = [];
    let fixed10 = [];
    let [ltv, cltv, hcltv] = getLtv();
    
    if (state != "TEXAS") _county = county;

    let aus = []
    for (let a of selectedAUS) {
      aus.push(a.label)
    }

    let body = {
      state: state,
      county: _county,
      purpose: purpose,
      loanAmount: getLoanAmount(),
      units: parseInt(_units),
      LTV: ltv,
      CLTV: cltv,
      HCLTV: hcltv,
      FICO: fico,
      occupancy: com.getOccupancy(occupancy),
      property: com.getPropertyType(propertyType),
      point: zeitro_fee,
      estimatedClosingCosts: parseFloat(estOtherCosts),
      pmi: pmi,
      getFiles: false,
      monthlyIncome: parseFloat(monthlyIncome),
      monthlyDebt: parseFloat(monthlyDebt),
      firsttimehomebuyer: firstTimeHomeBuyer==="Yes" ? true : false,
      selfemployed: selfEmployed,
      citizenship: citizenship,
      visaType: visaType,
      numberOfOwnedProperties: numberOfOwnedProperties,
      escrowWaiver: escrowWaiver === "true" ? true : false,
      appraisalWaiver: appraisalWaiver,
      currentJobInMonths: currentJobInMonths,
      rsuAsIncome: rsuAsIncome ? 10 : -1,
      giftFundUsed: giftFundUsed,
      familyRelatedOrSmallBusiness: workForSpecialBusiness,
      borrowerPaidCompensationAmount: borrowerPaidCompensationAmount,
      dti:dti,
      Rate_LMIBAdjustment: applyLMIB,
      Rate_LMITAdjustment: applyLMIT,
      Rate_MMCTAdjustment: applyMMCT,
      Rate_CRAAdjustment: applyExtraCRA,
    };
    // FORKED for PPE: send the CLEAN new PricingRequest over the wire (exposed as
    // pricingRequest by the forked formatSearchParams). No legacy /lopriceengine
    // field names leave the browser.
    const params = props.searchParams.pricingRequest || props.searchParams;
    setLoading(true);
    setAllRates({});
    setLoans([]);
    setNoProducts(false);
    setResultlenderSet(new Set());
    setConnectedLendersMap({});
    setLenderData([]);
    setSelectedLenders([]);
    // The lender dropdown shown above this table is owned by the parent. Clear
    // both copies at the start of every request so a no-product/non-Ok response
    // or a request failure cannot leave the previous search's lenders visible.
    if (onLendersChange) {
      onLendersChange([], []);
    }
    setIneligibleProducts({});
    setErrorTitle("");
    setErrorMessage("");
    fetch(ppePricingUrl(), {
      method: "POST",
      headers: ppeAuthHeaders(),
      body: JSON.stringify(params)
    })
      .then(parsePpeResponse)
      .then((prd) => {
          if (requestId !== pricingRequestIdRef.current) return;
          // console.log('prd------------', prd)
          if (prd.status !== "Ok") {
            setLoading(false);
            // message.error(prd.message);
            setErrorTitle(prd.status);
            setErrorMessage(prd.message);
            return;
          }
          setAppliedClosingCostsDetail(prd.appliedClosingCostsDetail);
          const noLendersAdded = Object.values(prd.connected_lender_map).every(value => value === false)
          setConnectedLendersMap(prd.connected_lender_map)
          // let products = prd.result;
          let products_filtered = [];

          // filter by loanTerm 、loanType、ausType
          // console.log('product result',prd.result, props.searchParams)
          if (prd.result) {
            prd.result.forEach(item => {
              let item_new = {...item};
              item_new.ProductRatesCosts = [];
              item.ProductRatesCosts.forEach((product, index) => {
                // loanTerm
                // if(props.searchParams.loanTerms.match(product.product.Term)){
                  // console.log('loanTerm---------')
                  // loanType
                  // if(props.searchParams.loanType && !props.searchParams.loanType.includes("")){
                  //   // 如果包含 "FHA" -> 认为是 "FHA"
                  //   // 如果包含 "VA" -> 认为是 "VA"
                  //   // 如果包含 "USDA" -> 认为是 "USDA-RD"
                  //   // 如果包含 "CONFORMING" -> 认为是 "Conventional"
                  //   // 如果还有其他类型 -> 认为是 "Other"
                  //   product.product.Mtype_to_loanType = "Other"
                  //   if(product.product.Mtype.includes("FHA")){
                  //     product.product.Mtype_to_loanType = "fha"
                  //   }else if(product.product.Mtype.includes("VA")){
                  //     product.product.Mtype_to_loanType = "va"
                  //   }else if(product.product.Mtype.includes("USDA")){
                  //     product.product.Mtype_to_loanType = "usda"
                  //   }else if(product.product.Mtype.includes("CONFORMING")){
                  //     product.product.Mtype_to_loanType = "conventional"
                  //   }
                  //   if(props.searchParams.loanType.includes(product.product.Mtype_to_loanType)){
                  //     // console.log('ausType---------')
                  //     // ausType
                  //     if(props.searchParams.ausTypes && props.searchParams.ausTypes.length > 0){
                  //       // 检查两个数组是否有交叉项
                  //       const intersection = props.searchParams.ausTypes.filter(aus => product.AUSEngine.includes(aus));
                  //       if(intersection.length > 0){
                  //         item_new.ProductRatesCosts.push(product)
                  //       }
                  //     }else{
                  //       item_new.ProductRatesCosts.push(product)
                  //     }
                  //   }
                  // }else{
                    item_new.ProductRatesCosts.push(product)
                  // }
                // }
              })
              products_filtered.push(item_new)
            })
          }

          let products = [...products_filtered]
          // console.log('----------products', products, props.searchParams.loanTerms, props.searchParams.loanType, props.searchParams.ausTypes)


          let prTypesSet = new Set();
          if (products !== undefined) {
            if (specificProgram !== undefined) {
              products = products.filter((p) => p.Lender === specificProgram);
            }
            let lenderSet = new Set();
            products.forEach((product) => {
              lenderSet.add(product.Lender);
            });
            setResultlenderSet(lenderSet);
            const data = Array.from(lenderSet).map((lender) => ({
              label: com.formatLenderDisplayName(lender),
              value: lender,
              myLenders: prd.connected_lender_map[lender] || false
            })).sort((a, b) => b.myLenders - a.myLenders)
            setLenderData(data)

            setSelectedLenders(showConnectedLendersOnly? Array.from(lenderSet).filter(x=>prd.connected_lender_map[x]): Array.from(lenderSet));
            if (onLendersChange) {
              onLendersChange(data, showConnectedLendersOnly? Array.from(lenderSet).filter(x=>prd.connected_lender_map[x]): Array.from(lenderSet));
            }
            // if no lenders are added
            if (noLendersAdded) {
              setShowConnectedLendersOnly(false);
              setShowIneligible(false);
              setShowAddLendersModal(true);
              setSelectedLenders(Array.from(lenderSet))
              if (onLendersChange) {
                onLendersChange(data, Array.from(lenderSet));
              }
            }            
          } 

          if (prd.ineligible_reasons != undefined) {
            if (specificProgram !== undefined) {
              if (prd.ineligible_reasons[specificProgram]) {
                let ine = {}
                ine[specificProgram] = prd.ineligible_reasons[specificProgram]
                setIneligibleProducts(ine);
              }
            } else {
              let ine = {}
              for (let key in prd.connected_lender_map) {
                if (prd.connected_lender_map[key]) {
                  if (prd.ineligible_reasons[key]) {
                    ine[key] = prd.ineligible_reasons[key]
                  }
                }
              }
              setIneligibleProducts(ine);
            }
          } else {
            setIneligibleProducts({});
          }
          if (products === undefined) {
            setNoProducts(true)
            setShowIneligible(true);
            if(prd.message ==="can not get lender fee data"){
              setShowIneligible(false);
              setShowAddLendersModal(true);
            }
            setLoading(false);
            return;
          } else {
            setNoProducts(false)
          }
          products.forEach((product) => {
            let lender = product.Lender;
            let fb = product.FileB;
            product.ProductRatesCosts.forEach((pr) => {
              let commonproduct = pr.product;
              let adjustments = pr.appliedAdjustments;
              let ausengine = pr.AUSEngine;
              if (showConnectedLendersOnly && !noLendersAdded) {
                if (prd.connected_lender_map[lender]) {
                  prTypesSet.add(commonproduct.Mtype);
                }
              } else {
                prTypesSet.add(commonproduct.Mtype);
              }

              pr.rateCosts.forEach((rate) => {
                let pdkt = {
                  FileInfo: product.FileInfo,
                  Lender: lender,
                  ...commonproduct,
                  Aus: ausengine,
                  ...rate,
                  Adjustments: adjustments,
                  FileB: fb,
                };

                // if(props.searchParams.compensationType === "borrower_paid" && rate.lender_credit < 0){
                //   return;
                // }

                // if(props.searchParams.compensationType === "lender_paid" && rate.lender_credit > 0){
                //   return;
                // }
                
                if (Number(rate.lockDay) !== Number(props.searchParams.lockDay)) { // lockDay
                  return;
                }
                let commonAUS = selectedAUS.filter(val => pdkt.Aus.includes(val.label));
                if (commonAUS.length === 0) {
                  return
                }
                const filterPdkt = () => {
                  if (customerid==="siliconcitymortgage" && pdkt.Mtype.includes("FHA")) {
                    return false
                  }
                  return true
                }

                /// SOMRTHING ELSE HERE
                pdkt.loanAmount = getLoanAmount();
                if (filterPdkt()) {
                  if (pdkt.Arm != null) {
                    if (pdkt.Arm.fixedperiod == 5) {
                      arm56.push(pdkt);
                    } else if (pdkt.Arm.fixedperiod == 7) {
                      arm76.push(pdkt);
                    } else if (pdkt.Arm.fixedperiod == 10) {
                      arm106.push(pdkt);
                    } else if (pdkt.Arm.fixedperiod == 3) {
                      arm31.push(pdkt);
                    }
                  } else {
                    if (pdkt.Term == 40) {
                      fixed40.push(pdkt);
                    } else if (pdkt.Term == 30) {
                      fixed30.push(pdkt);
                    } else if (pdkt.Term == 25) {
                      fixed25.push(pdkt);
                    } else if (pdkt.Term == 20) {
                      fixed20.push(pdkt);
                    } else if (pdkt.Term == 15) {
                      fixed15.push(pdkt);
                    } else if (pdkt.Term == 10) {
                      fixed10.push(pdkt);
                    }
                  }
                }
              });
            });
          });
          
          let compareRate = (a, b) => {
            if (a.base_rate !== b.base_rate) return a.base_rate - b.base_rate;

            return a.closing_cost - b.closing_cost; // take into account remaining credits
          };

          let cullRate = (products) => {
            const filteredPrds = products.filter((p) => {
              return p.lender_credit > 0;
            });

            if (filteredPrds.length === 0) return filteredPrds;
            let newproducts = [];
            newproducts.push(filteredPrds[0]);
            let base_rate = filteredPrds[0].base_rate;
            let closing_cost = filteredPrds[0].closing_cost;

            for (let i = 1; i < filteredPrds.length; i++) {
              if (filteredPrds[i].base_rate !== base_rate) {
                if (filteredPrds[i].closing_cost < closing_cost) {
                  newproducts.push(filteredPrds[i]);
                  closing_cost = filteredPrds[i].closing_cost;
                }
                base_rate = filteredPrds[i].base_rate;
              } else {
              }
            }
            return newproducts;
          };

          let getIndex = (loans) => {
            let bestIndex = 0;
            let bestPoints = 1000000;
            for (let i = 0; i < loans.length; i++) {
              if (Math.abs(loans[i].lender_credit - 1500) < bestPoints) {
                bestPoints = Math.abs(loans[i].lender_credit - 1500);
                bestIndex = i;
              }
            }
            return bestIndex;
          };
          let matchingProductTypes = (arr) => {
            let detectedTypes = []
            for (let type of arr) {
              for (let key of Object.keys(productTypesMap)) {
                if (productTypesMap[key].includes(type)) {
                  detectedTypes.push(key)
                }
              }
            }
            setProductTypes(detectedTypes)
          }
          
          matchingProductTypes(Array.from(prTypesSet));

          setAllRates({
            fixed40,
            fixed30,
            fixed25,
            fixed20,
            fixed15,
            fixed10,
            arm56,
            arm76,
            arm106,
            arm31,
          });
          fixed40.sort(compareRate);
          fixed30.sort(compareRate);
          fixed25.sort(compareRate);
          fixed20.sort(compareRate);
          fixed15.sort(compareRate);
          fixed10.sort(compareRate);
          arm56.sort(compareRate);
          arm76.sort(compareRate);
          arm106.sort(compareRate);
          arm31.sort(compareRate);
          fixed40 = cullRate(fixed40);
          fixed30 = cullRate(fixed30);
          fixed25 = cullRate(fixed25);
          fixed20 = cullRate(fixed20);
          fixed15 = cullRate(fixed15);
          fixed10 = cullRate(fixed10);
          arm56 = cullRate(arm56);
          arm76 = cullRate(arm76);
          arm106 = cullRate(arm106);
          arm31 = cullRate(arm31);


          setIndexFixed30(getIndex(fixed30));
          setIndexFixed25(getIndex(fixed25));
          setIndexFixed20(getIndex(fixed20));
          setIndexFixed15(getIndex(fixed15));
          setIndexFixed10(getIndex(fixed10));
          setIndexArm56(getIndex(arm56));
          setIndexArm76(getIndex(arm76));
          setIndexArm106(getIndex(arm106));

          if (fixed30.length !== 0) {
            setLoans(fixed30);
          } else if (fixed40.length !== 0) {
            setLoans(fixed40);
          } else if (arm56.length !== 0) {
            setLoans(arm56);
          } else {
            const nonEmpty = [arm76, arm106, arm31, fixed25, fixed20, fixed15, fixed10].find((b) => b.length !== 0);
            if (nonEmpty) setLoans(nonEmpty);
          }
          setLoading(false);
      })
      .catch((err) => {
        if (requestId !== pricingRequestIdRef.current) return;
        setErrorTitle(err.title || "Pricing request failed");
        setErrorMessage(err.message || "An internal error has occurred");
        console.log('error: ', err)
        setLoading(false)
      })
  }


  const getLoanLimits = () => {
    setLoading(true);
    fetch("/data/loanlimits")
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res.json();
      })
      .then((res) => {
        setLoanLimits(res);
        // setLoading(false);
      })
      .catch((err) => {
        // setLoading(false);
      });
    };


  const ref = useRef();
  const formContainerRef = useRef(null);

  const measureFormContainerHeight = () => {
    if (formContainerRef.current) {
      setFormContainerHeight(formContainerRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    measureFormContainerHeight();

    window.addEventListener("resize", measureFormContainerHeight);

    return () => {
      window.removeEventListener("resize", measureFormContainerHeight);
    }
  },[]);

  useEffect(() => {
    if (celebrityState !== "" && celebrityCounty !== "") {
      setLoadingTractData(true)
      fetch("/data/loanlimitswithincome", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Address: celebrityAddress,
          State: celebrityState,
          City: city,
          Zip: zip,
        })
      })
        .then((res) => {
          if (!res.ok) {
            setShowUnavailable(true)
            setLoadingTractData(false)
            return
          }
          res.json().then((js) => {
            setShowUnavailable(false)      
            setMfi(js.MedianIncome)
            setIncomeIndicator(js.IncomeIndicator)
            setMinority(js.MinorityPercent)
            setTotalPopulation(js.TotalPopulation)
            setHispanic(js.Hispanic)
            setBlack(js.Black)
            setAsian(js.Asian)
            setPacific(js.Pacific)
            setMsaCode(js.MsaCode)
            setLoadingTractData(false)
        })
    })
    .catch((err) => {
        
    });
    }
  }, [celebrityCounty, celebrityState, celebrityAddress]);

  useEffect(() => {
    if (celebrityState !== "" && celebrityCounty !== "") {
        fetch("/data/gethudmedianfamilyincome", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              State: celebrityState,
              County: celebrityCounty,
            })
          })
            .then((res) => {
              if (!res.ok) {
                setMedianIncome(181300)
                return
              }
              res.json().then((js) => {
                setMedianIncome(js.MedianIncome)
              });
            })
            .catch((err) => {
              
            })
    }   
  },[celebrityAddress,celebrityCounty,celebrityState])

  useEffect(() => {
    const myObserver = new ResizeObserver((entries) => {
      if (entries.length > 0) {
        let height = entries[0].contentRect.height;
        let width = entries[0].contentRect.width;
        window.parent.postMessage(
          { source: "tools", payload: ["100%", height + 39] },
          "*"
        );
      }
    });
    if (ref.current) myObserver.observe(ref.current);
  });

  useEffect(() => {
    let specialAdj = {}
    let total = 0
    if (purpose === "Purchase" && occupancy==="principal" && loanTerm === "fixed30" && (zeroDown_qualifiedCounties[celebrityState] !== undefined && (zeroDown_qualifiedCounties[celebrityState].length===0|| zeroDown_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim())))){
      if (monthlyIncome*12 <= mfi*0.8){
        setApplyLMIB(true)
        specialAdj["LMIB"] = mapSpecialAdjustments["LMIB"]
        total += mapSpecialAdjustments["LMIB"]
      }
      if (incomeIndicator === 1 || incomeIndicator === 2){
        setApplyLMIT(true)
        specialAdj["LMIT"] = mapSpecialAdjustments["LMIT"]
        total += mapSpecialAdjustments["LMIT"]
      }
      if (minority > 50){
        if ((tenK_qualifiedCounties[celebrityState] !== undefined && (tenK_qualifiedCounties[celebrityState].length===0|| tenK_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim())))){
          setApplyMMCT(true)
          specialAdj["MMCT"] = mapSpecialAdjustments["MMCT_10K"]
          total += mapSpecialAdjustments["MMCT_10K"]
        }
        if ((thirtyK_qualifiedCounties[celebrityState] !== undefined && (thirtyK_qualifiedCounties[celebrityState].length===0|| thirtyK_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim())))){
          setApplyMMCT(true)
          specialAdj["MMCT"] = mapSpecialAdjustments["MMCT_30K"]
          total += mapSpecialAdjustments["MMCT_30K"]
        }
      }
    }
    if (loanTerm === "fixed30"){
      if((tenK_qualifiedCounties[celebrityState] !== undefined && (tenK_qualifiedCounties[celebrityState].length===0|| tenK_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim()))) && 
      (monthlyIncome*12 <= mfi*1.5 || (monthlyIncome*12 <= mfi*2 && firstTimeHomeBuyer)) && 
      (minority>50 || incomeIndicator === 1 || incomeIndicator === 2) &&
      fico >=620 && getLoanAmount()>=25000 && getLoanAmount()<=832750 && getLtv()[0]>=75
    ){
        setApplyExtraCRA(true)
        specialAdj["CRA"] = mapSpecialAdjustments["CRA_10K"]
        total += mapSpecialAdjustments["CRA_10K"]
      }
      if((thirtyK_qualifiedCounties[celebrityState] !== undefined && (thirtyK_qualifiedCounties[celebrityState].length===0|| thirtyK_qualifiedCounties[celebrityState].includes(celebrityCounty.replace("County", "").trim()))) && 
      (monthlyIncome*12 <= mfi*1.5 || (monthlyIncome*12 <= mfi*2 && firstTimeHomeBuyer)) && 
      (minority>50 || incomeIndicator === 1 || incomeIndicator === 2) &&
      fico >=620 && getLoanAmount()>=25000 && getLoanAmount()<=832750 && getLtv()[0]>=80
    ){
        setApplyExtraCRA(true)
        specialAdj["CRA"] = mapSpecialAdjustments["CRA_30K"]
        total += mapSpecialAdjustments["CRA_30K"]
      }
    }
    specialAdj["Total"] = total
    setSpecialAdjustments(specialAdj)

  }, [minority, medianIncome, incomeIndicator, firstTimeHomeBuyer, celebrityState, celebrityCounty, monthlyIncome, purpose, occupancy, loanTerm, mfi]);

  useEffect(() => {
    getloanestimatedclosingfee()
    
    getLoanLimits();

    let token = sessionStorage.getItem("ZeitroA");
    fetch("/los/getprofile", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          alert(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }
        response.json().then((js) => {
          if (js.Status !== "OK") {
            
          } else {
            let lo = js.LoanOfficers[0];
            setLOProfile({
              firstName: lo.FirstName,
              lastName: lo.LastName,
              email: lo.Email,
              phone: lo.Phone,
              avatarsrc: lo.Image,
              nmls: lo.Nmls,
            });
          }
        });
      })
      .catch(function (err) {
        
      });
  }, []);
  useEffect(() => {
    if (!closingFeeConfig) return;
  
    const lodeStar = lodeStarConfig || {};
    const shouldCalculate =
      lodeStar.enableCanShopServices === false &&
      lodeStar.enableTaxesAndOtherGovernmentFees === false &&
      lodeStar.enableOther === false;
  
    setIsCalculatedAtResults(!shouldCalculate);
  
    if (shouldCalculate) {
      const calculateArrayTotal = (arr) => {
        if (!arr) return 0;
        return arr.reduce((sum, item) => sum + (Number(item.estimateAmount) || 0), 0);
      };
  
      const total =
        calculateArrayTotal(closingFeeConfig.canNotShopServices) +
        calculateArrayTotal(closingFeeConfig.canShopServices) +
        calculateArrayTotal(closingFeeConfig.taxesAndOtherGovernmentFees) +
        calculateArrayTotal(closingFeeConfig.prepaids) +
        calculateArrayTotal(closingFeeConfig.initialEscrowPaymentsAtClosing) +
        calculateArrayTotal(closingFeeConfig.other) +
        calculateArrayTotal(closingFeeConfig.originationCharges);
  
      setEstOtherCosts(total);
    } else {
      setEstOtherCosts('Calculated at results');
    }
  }, [lodeStarConfig, closingFeeConfig]);
  const getloanestimatedclosingfee = () => {
    let token = sessionStorage.getItem("ZeitroA");
    fetch("/los/getloanestimatedclosingfee", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    })
    .then((response) => {
      if (response.status !== 200) {
        alert(
          "Looks like there was a problem. Status Code: " + response.status
        );
        return;
      }
      response.json().then((js) => {
        if (js.status !== "OK") {
          
        } else {
          let data = js.configurations;
          if (data.estimatedClosingCostsDetail) {
            setClosingFeeConfig(data.estimatedClosingCostsDetail);
          }
          if (data.lodeStarConfig) {
            setLodeStarConfig(data.lodeStarConfig);
          }
        }
      })
    })
    .catch(function (err) {
      
    })
  }
  useEffect(() => {
    if (!showSubscribe) setShowRatePreview(false);
  }, [showSubscribe, showRatePreview]);

  useEffect(() => {
    setMonthlyDebt(parseInt(monthlyIncome * dti / 100));
  }, [monthlyIncome, dti]);

  useEffect(() => {
    // console.log("selectedLendersFromFilter", props.selectedLendersFromFilter);
    if (JSON.stringify(props.selectedLendersFromFilter) !== JSON.stringify(selectedLenders)) {
      setSelectedLenders(props.selectedLendersFromFilter);
    }
  }, [props.selectedLendersFromFilter]);


  let showCounties = () => {
    let options = [<option value="">Select your county</option>];
    if (state in loanLimits) {
      let keys = Object.keys(loanLimits[state]);
      
      keys.forEach((x) => {
        options.push(<option value={x}> {com.capitalize(x)}</option>);
      });
    }
    return options;
  };

  let showStates = () => {
    let options = [<option value="">Select your state</option>];
    let keys = Object.keys(loanLimits);

    keys.forEach((x) => {
      options.push(<option value={x}> {com.capitalize(x)}</option>);
    });
    return options;
  }

  let updateTargetPrice = (e) => {
    let val = e.target.value;
    if (val === "") {
      setTargetPriceDollar(0);
      setTargetPricePoint(0);
    } else {
      let num = parseInt(val);
      setTargetPriceDollar(num);
      setTargetPricePoint(num * 100);
    }
  };

  let handleCalcOptionChange = (value) => {
    setCalcOptions(value);
  };

  let handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (form.current.reportValidity() === false) {
      setValidated(true);
      return false;
    }
 
    if (parseInt(downpayment) >= parseInt(propertyValue)) {
      setValidated(true);
      const mapLabel = {
        "Purchase": "Down payment",
        "RateTermRefi": "Loan amount",
        "CashOutRefi": "Loan amount"
      }
      alert(`${mapLabel[purpose]} can't be bigger than ${purpose === "Purchase" ? "Property value" : "Home value"}` );
      return false;
    }
    const parsedFico = parseInt(fico);
    if (!Number.isFinite(parsedFico) || parsedFico < CREDIT_SCORE_MIN || parsedFico > CREDIT_SCORE_MAX) {
      setValidated(true);
      alert(`FICO score should be in the range of ${CREDIT_SCORE_MIN} - ${CREDIT_SCORE_MAX}`);
      return false;
    }
    setNotmodified(false);
    setShowForm(false);
    getProducts();
    setExtended(false)
    return false;
  };

  let onMoreOptions = (e) => {
    if (showMoreOptions) {
      setShowMoreOptions(false);
    } else {
      setShowMoreOptions(true);
    }
  };

  let handleCheckProduct = (name) =>{
    let i=parseInt(name)
    let newproducts=[...stdproducts];
    if(newproducts[i].status == "checked"){
      newproducts[i].status = "unchecked"
    }else{
      newproducts[i].status = "checked"
    }
    setStdProducts(newproducts);
  };

  let handleClearProducts = () => {
    let newstdproducts=[...stdproducts];
    newstdproducts.forEach(newstdproduct=>newstdproduct.status="unchecked");
    setStdProducts(newstdproducts);
  };
  let getEditCostsModal = () => {
    const handleLodestarChange = (checked) => {
      setLodeStarConfig({
          ...lodeStarConfig,
          "enableCanNotShopServices": checked,
          "enableCanShopServices": checked,
          "enableTaxesAndOtherGovernmentFees": checked,
          "enablePrepaids": checked,
          "enableInitialEscrowPaymentsAtClosing": checked,
          "enableOther": checked
      })
    }
    const handleConfigChange = (newConfig) => {
      setLodeStarConfig(newConfig)
    }
    const handleSaveClosingFee = () => {
      setEstOtherCosts(totalClosingFee)
      const closingFee = closingCostRef.current.getClosingFee()
      setClosingFeeConfig(closingFee)
      handleEditCostDetailsModal()
    }
    return (
      <Modal
          className="edit-fees-modal"
          centered
          destroyOnClose
          maskClosable={true}
          width={974}
          open={showEditCostDetails}
          title=""
          onCancel={handleEditCostDetailsModal}
          footer={null}
      >
        <div className="edit-fees-modal-title">Closing cost details</div>
        <div className="edit-fees-modal-content">
          <div style={{marginBottom: 12}}>
              <LodestarTipsCard initialConfig={lodeStarConfig} onLodestarChange={handleLodestarChange} />
          </div>
          <div className="estimatedclosingfee-container">
              <ClosingCost 
                  ref={closingCostRef}
                  initialConfig={lodeStarConfig}
                  initialClosingFee={closingFeeConfig}
                  onConfigChange={handleConfigChange}
                  onTotalFeesChange={(totalFees) => setTotalClosingFee(totalFees)}
              />
          </div>
          {/* <Form
            style={{
              height: 'calc(100vh - 400px)',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            <div className="edit-fees-form-label">Services you <span style={{fontWeight: 600}}>CANNOT</span> shop for</div>
            {cannotshop.map((element, index) => (
              <Row gutter={2}>
                <Col sm={13} span={24}>
                  <AutoComplete
                      name="name"
                      className="estFee-select"
                      options={cannotshopOptions}
                      style={{
                        width: "100%",
                        height: 50,
                        marginBottom: 12
                      }}
                      value={element.name || ""}
                      filterOption={(inputValue, option) =>
                          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      onChange={(value) => handleCannotshop(index, { target: { name: 'name', value } })}
                      onSelect={(value, option) => selectCannotshop(index, option)}
                  />
                </Col>
                <Col sm={8} span={24}>
                  <InputNumber
                    className="estFee-input"
                    name="value"
                    formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
                    value={element.value || ""}
                    onChange={(value) => handleCannotshop(index, { target: { name: "value", value } })}
                  />
                </Col>
                <Col sm={2} span={24}>
                  <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingLeft: 6, paddingBottom: 12 }}>
                    <img style={{ cursor: 'pointer' }} src="/images/delete.svg" onClick={() => removeCannotshop(index)} />
                  </div>
                </Col>
              </Row>
            ))}
            <div className="estFee-add-more" onClick={() => addCannotshop()}>Add more</div>
            <div className="edit-fees-form-label">Services you <span style={{fontWeight: 600}}>CAN</span> shop for</div>
            {canshop.map((element, index) => (
              <Row gutter={2}>
                <Col sm={13} span={24}>
                  <AutoComplete
                      name="name"
                      className="estFee-select"
                      options={canshopOptions}
                      style={{
                        width: "100%",
                        height: 50,
                        marginBottom: 12
                      }}
                      value={element.name || ""}
                      filterOption={(inputValue, option) =>
                          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      onChange={(value) => handleCanshop(index, { target: { name: 'name', value } })}
                      onSelect={(value, option) => selectCanshop(index, option)}
                  />
                </Col>
                <Col sm={8} span={24}>
                  <InputNumber
                    className="estFee-input"
                    name="value"
                    formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
                    value={element.value || ""}
                    onChange={(value) => handleCanshop(index, { target: { name: "value", value } })}
                  />
                </Col>
                <Col sm={2} span={24}>
                  <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingLeft: 6, paddingBottom: 12 }}>
                    <img style={{ cursor: 'pointer' }} src="/images/delete.svg" onClick={() => removeCanshop(index)} />
                  </div>
                </Col>
              </Row>
            ))}
            <div className="estFee-add-more" onClick={() => addCanshop()}>Add more</div>
          </Form> */}
        </div>

        <div className="edit-fees-modal-footer">
          <Button className="edit-fees-modal-close-btn" type="link" variant="customize" onClick={handleEditCostDetailsModal}>
            Cancel
          </Button>
          <div className="edit-fees-modal-footer-right">
            <Button className="edit-fees-modal-save-btn" variant="primary" onClick={handleSaveClosingFee}>
              Save and apply
            </Button>
          </div>
        </div>
      </Modal>
    );
  };
  const updateProperValue = (e) => {
    let val = e.target.value
    if (downpayment > val) {
      updateDownpayment({target: { value: val > 0 ? Number(val) - 1 : 0 }})
    }
    setEmptyLtv(false)
    if (val==="") {
      setEmptyPropertyVal(true)
      setPropertyValue(100000)
    } else {
      setEmptyPropertyVal(false)
      setPropertyValue(parseInt(val))
    }
  }
  const updateMonthlyIncome = (e) => {
    let val = e.target.value
    if (val==="") {
      setEmptymonthlyIncome(true)
      setMonthlyIncome(0)
    } else {
      setEmptymonthlyIncome(false)
      setMonthlyIncome(parseInt(val))
    }
  }
 
  const updateDownpayment = (e) => {
    let val = e.target.value
    if (val > propertyValue) {
      updateProperValue({target: { value: val > 0 ? Number(val) + 1 : 0 }})
    }
    setEmptyLtv(false)
    if (val==="") {
      setDownpayment(Math.round(propertyValue * 0.03))
      setEmptyDownpay(true)
    } else {
      setEmptyDownpay(false)
      setDownpayment(parseInt(val))
    }
  }
  const updateLTV = (e) => {
    let val = e.target.value
    setEmptyDownpay(false)
    if (val==="") {
      setDownpayment(Math.round(propertyValue))
      setEmptyLtv(true)
    } else {
      let ltv = parseFloat(val)
      setEmptyLtv(false)
      if (ltv <= 0) { // TBD
        setDownpayment(Math.round(propertyValue))
      } else if (ltv > 100) {
        setDownpayment(Math.round(propertyValue * 0))
      } else {
        if(purpose==="Purchase"){
          setDownpayment(Math.round(propertyValue * (1 - 0.01 * ltv)))
        }
        else{
          setDownpayment(Math.round(propertyValue * (0.01 * ltv)))
        }
      }
    }
  }

  const updateDTI = (e) => {
    let val = e.target.value
    setEmptyDTI(false)
    if (val==="") {
      setDTI(0)
      setEmptyDTI(true)
    } else {
      setEmptyDTI(false)
      setDTI(parseInt(val))
      // setMonthlyDebt(parseInt(val) * 0.01 * parseInt(monthlyIncome))
    }
  }
  const handleChangeEmployment = (e) => {
    setEmployment(e.target.value)
    if (e.target.value==="Selfemployed") {
      setSelfEmployed(true)
    }
  }

  const radioOptions=[
    {
      label:"Purchase",
      value:"Purchase"
    },
    {
      label:"Refinance",
      value:"RateTermRefi"
    },
    {
      label:"Cashout",
      value:"CashOutRefi"
    }
  ]

  const onRadioChange=({target:{value}}) =>{
    setPurpose(value);
  }
  const handleExpandButtonClick = () => {
    setExtended(!extended);
}

  const onStreetAddressCompletion = (address) => {
    let num = com.getSubaddress(address, "street_number", "long_name");

    let city = com.getSubaddress(address, "locality", "long_name");
    setCity(city)
    let state = com.getSubaddress(
      address,
      "administrative_area_level_1",
      "short_name"
    );

    let zip = com.getSubaddress(address, "postal_code", "long_name");
    setZip(zip)

    let longstate = com.getSubaddress(
      address,
      "administrative_area_level_1",
      "long_name"
    );
    setCelebrityState(longstate)
    setState(longstate.toUpperCase())

    let county = com.getSubaddress(
      address,
      "administrative_area_level_2",
      "long_name"
    );
    setCelebrityCounty(county)
    setCounty(county.toUpperCase())

    let short = com.getSubaddress(address, "route", "long_name");
    setCelebrityAddress(num + " " + short)
    let stradd = num + " " + short + ", " + city + ", " + state + " " + zip;
    setDisplayedAddress(stradd)
    setSkipCRA(false)
  };

  const handleManagementDirect = () => {
    if(window.location.hostname.includes("localhost")){
      window.location.href = "http://localhost:3001/app/management"
    }else{
      window.location.href = "https://lo.zeitro.com/app/management"
    }
  }

  const onEligibilityViewChange = (e) => {
    setEligibilityView(e);
  }

  const getFormBody = () => {
    return (
      <div
      style={{maxWidth:"1050px",display:"flex",flexDirection:"column",justifyContent:"space-between",height:notmodified?formContainerHeight-30:formContainerHeight-60}}
      className="ratequoterForm"
    >
      <div style={{height:formContainerHeight-120,overflowY:"auto", overflowX:"hidden"}}>
      <div style={{textAlign:'center',marginBottom:"20px"}}>
            <Radio.Group
              className="search-fields-tabs"
              options={radioOptions}
              onChange={onRadioChange}
              value={purpose}
              optionType="button"
              buttonStyle="solid"
            />
      </div> 
      <hr style={{borderTop:"1px solid #DBDCDE"}}/> 
      {props.specificProgram === "GMCCCelebrities" && <>
      <Row gutter={20}>
        <Col md={16}>
          <AddressAutocomplete
            id='scenario-address'
            label="Property address"
            required={false}
            name="addessline"
            defaultValue={displayedAddress}
            onChange={(e) => setDisplayedAddress(e.target.value)}
            pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
            placeholder="Please type your home address and select from the dropdown addresses"
            goodfeedback="Looks good!"
            badfeedback="Please provide your street address."
            onCompletion={e => onStreetAddressCompletion(e)}
            size="md"
          />
        </Col>
        <Col md={8}>
          <Form.Group className="text-left">
            <Form.Label className="ratequoterFormLabels">
              {" "}
            </Form.Label>
            <Popover 
              overlayClassName="tractInfoTip" 
              placement="bottom"
              content={
                skipCRA?
                <div style={{display:"flex",justifyContent:"center", color:"red", fontWeight:"500"}}>Pleas enter target address first.</div>
                :
                showUnavailable?
                <div style={{color:"#CB8600", display:"flex",justifyContent:"center", fontWeight:"500"}}>Tract info currently unavailable, you can still proceed to search rates without incentives.</div>
                :
                tractInfo
              }
            >
              <div className="tractInfoBtn">{loadingTractData?<Spin />:"Show tract info on this address"}</div>
            </Popover>
          </Form.Group>
        </Col>

        {showUnavailable && <Col className="mb-3" md={24}>
          <div className="incentiveUnavailable">Special incentives check currently unavailable, you can still proceed to search rates for standard programs.</div>
        </Col>}
      </Row>
      </>
      }
      <Row gutter={20}>
        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group className="text-left ">
            <Form.Label className="ratequoterFormLabels">
              {purpose === "Purchase"
                ? "Property value"
                : "Home value"}
            </Form.Label>
            <div className="formCommaizedInput">
              <div className="prefix">$</div>
              <CommaizedInput value={emptyPropertyVal?"":propertyValue} onChange={updateProperValue} />
            </div>
          </Form.Group>
        </Col>

        <Col md={8} style={{marginBottom:"0px", paddingRight:"10px"}}>
          <Form.Group className="text-left ">
            <Form.Label
              className="ratequoterFormLabels text-left"
            >
              {purpose === "Purchase"
                ? "Down payment"
                : "Loan amount"}
            </Form.Label>
            {/* <div className="rateQuoterFormSliderOutline"> */}
            <div className="formCommaizedInput">
              <div className="prefix">$</div>
              <CommaizedInput value={emptyDownpay?"":downpayment} onChange={updateDownpayment} />
            </div>
          </Form.Group>
        </Col>

        <Col md={8} style={{marginBottom:"0px", paddingRight:"10px"}}>
          <Form.Group className="text-left" style={{display:"flex", flexDirection:"column"}}>
            <Form.Label className="ratequoterFormLabels">
              LTV
            </Form.Label>
            <div className="formInputWithSuffix">
              <input className="ltv" type="number" style={{minWidth:"15px",border:"none",paddingLeft:"10px"}} value={emptyLtv?"":getLtv()[0]} onChange={updateLTV}/>
              <div className="ltvSuffix" style={{marginRight:"10px", backgroundColor:"#FCFCFC"}}>%</div>
            </div>
          </Form.Group>
        </Col>
  
        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group className="text-left ">
            <Form.Label className="ratequoterFormLabels">
              Loan term
            </Form.Label>
            <Form.Control
              size="sm"
              as="select"
              onChange={(e) => setLoanTerm(e.target.value)}
              value={loanTerm}
              required
            >
              <option value="fixed40">Fixed 40 year</option>
              <option value="fixed30">Fixed 30 year</option>
              <option value="fixed25">Fixed 25 year</option>
              <option value="fixed20">Fixed 20 year</option>
              <option value="fixed15">Fixed 15 year</option>
              <option value="fixed10">Fixed 10 year</option>
              <option value="arm5">ARM 5 Year</option>
              <option value="arm7">ARM 7 Year</option>
              <option value="arm10">ARM 10 Year</option>

            </Form.Control>
          </Form.Group>
        </Col>

        <Col md={8}  style={{marginBottom:"0px",paddingRight:"10px"}} >
          <Form.Group controlId="occupancy" className="text-left ">
            <Form.Label
              className="ratequoterFormLabels"
            >
              Occupancy
            </Form.Label>
            <Form.Control
              name="occupancy"
              as="select"
              size="sm"
              defaultValue={occupancy}
              onChange={(e) => {
                onOccupancy(e.target.value);
              }}
            >
              <option value="principal">Primary Residence</option>
              <option value="secondhome">Second Home</option>
              <option value="investment">Investment</option>
            </Form.Control>
          </Form.Group>
        </Col>

        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}} >
          <Form.Group controlId="propertytype" className="text-left ">
            <Form.Label className="ratequoterFormLabels">
              Property type
            </Form.Label>
            <Form.Control
              name="propertytype"
              as="select"
              size="sm"
              type="text"
              required
              value={propertyType}
              onChange={(e) => setPropertyType(e.target.value)}
            >
              <option value=""></option>
              <option value="singlefamilydetached">
                Single Family Home, Detached
              </option>
              <option value="singlefamilyattached">
                Single Family Home, Attached
              </option>
              <option value="condominiumdetached">
                Condominium, Detached
              </option>
              <option value="condominium">Condominium, Attached</option>
              <option value="pudattached">
                Planned Unit Development, attached
              </option>
              <option value="puddetached">
                Planned Unit Development, detached
              </option>
              <option value="twotofourfamily">
                2 to 4 Unit Multifamily
              </option>
              <option value="manufacturedhome">Manufactured Home</option>
            </Form.Control>
          </Form.Group>
        </Col>
        {propertyType === "twotofourfamily" ? (
          <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
            <Form.Group controlId="propertytype" className="text-left ">
              <Form.Label 
                className="ratequoterFormLabels"
              >
                Number of units
              </Form.Label>
              <Form.Control
                name="propertytype"
                as="select"
                size="sm"
                type="text"
                required
                value={units}
                onChange={(e) => setUnits(e.target.value)}
              >
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </Form.Control>
            </Form.Group>
          </Col>
        ) : (
          ""
        )}

        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group className="text-left ">
            <Form.Label className="ratequoterFormLabels">State</Form.Label>
            <Form.Control
              size="sm"
              as="select"
              id="state"
              onChange={(e) => setState(e.target.value)}
              required
              value={state}
            >
              {showStates()}
            </Form.Control>
          </Form.Group>
        </Col>
        {state !== "TEXAS" ? (
          <Col md={8} style={{marginBottom:"0px", paddingRight:"10px"}} >
            <Form.Group className="text-left ">
              <Form.Label className="ratequoterFormLabels">
                County
              </Form.Label>
              <Form.Control
                size="sm"
                as="select"
                id="country"
                name="country"
                onChange={(e) => setCounty(e.target.value)}
                value={county}
                required
              >
                {showCounties()}
              </Form.Control>
            </Form.Group>
          </Col>
        ) : (
          ""
        )}
        
        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group controlId="firstTimeHomeBuyer" className="text-left ">
            <Form.Label
              className="ratequoterFormLabels"
            >
              {specificProgram==="GMCCCelebrities"?"First generation home buyer" :"First time home buyer"}
            </Form.Label>
            <Form.Control
              name="firstTimeHomeBuyer"
              as="select"
              size="sm"
              defaultValue={firstTimeHomeBuyer}
              onChange={(e) => {
                setfirstTimeHomeBuyer(e.target.value);
              }}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </Form.Control>
          </Form.Group>
        </Col>
      
        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group className="text-left ">
            <Form.Label className="ratequoterFormLabels">
              Credit score
            </Form.Label>
            <Form.Control
              size="sm"
              as="input"
              onChange={(e) => e.target.value===""? setFico(0) : setFico(parseInt(e.target.value))}
              value={fico}
              placeholder="Enter credit score"
              required
            ></Form.Control>
          </Form.Group>
        </Col>

        {!(incomeCondition ==="noincome") && <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group className="text-left ">
            <Form.Label className="ratequoterFormLabels">
              Monthly income
            </Form.Label>
            <div className="formCommaizedInput">
              <div className="prefix">$</div>
              <CommaizedInput value={emptymonthlyIncome?"":monthlyIncome} onChange={updateMonthlyIncome} />
              {specificProgram === "GMCCCelebrities" && <div className="prefix">${com.commaize(monthlyIncome*12)}/yr</div>}
            </div>
          </Form.Group>
        </Col>}

        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group className="text-left ">
            <Form.Label
              className="ratequoterFormLabels"
            >
              Current DTI
            </Form.Label>
            <div className="formInputWithSuffix">
              <input className="ltv" type="number" style={{minWidth:"15px",border:"none",paddingLeft:"10px"}} value={emptydti?"":dti} onChange={updateDTI}/>
              <div className="ltvSuffix" style={{marginRight:"10px", backgroundColor:"#FCFCFC"}}>%</div>
            </div>
          </Form.Group>
        </Col>
      
        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
            <Form.Group className="text-left ">
              <Form.Label className="ratequoterFormLabels">
                Lock day
              </Form.Label>
              <Form.Control
                size="sm"
                as="select"
                onChange={(e) => setLockDay(parseInt(e.target.value))}
                value={lockDay}
                required
              >
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="45">45</option>
                <option value="60">60</option>
                <option value="75">75</option>
              </Form.Control>
            </Form.Group>
          </Col>
        <Col md={24}>
          <div className=" d-flex text-left" style={{ marginBottom: "0px", fontWeight:"500", fontSize:"12px",lineHeight:"20px",color:'#586570'}}>
              Target price (Base 100)
          </div>
          <div className="targetPriceFilter">
            <div className="targetPriceInputWrap">
              {pointFormat ? (
                <>
                  <input type="number" className="targetPriceInput" value={targetPricePoint} onChange={e=>setTargetPricePoint(e.target.value)} />
                  <div className="inputSign">%</div>
                </>
              ) : (
                <>
                  <div style={{backgroundColor:"#FCFCFC", marginLeft:"10px",borderRight:"1px solid #CFD4D9",paddingTop:"13px",paddingBottom:"13px",paddingRight:"8px"}}>$</div>
                  <CommaizedInput style={{border:"none"}} className="targetPriceInput" value={targetPriceDollar} onChange={updateTargetPrice} />
                </>
              )}
            </div>
            <div className="calcOptionSelectWrap">
              <div className="calcOptionsPrefix">Includes</div>
              <Select 
                mode= "multiple"
                className="calcOptionsSelect"
                allowClear
                value={calcOptions}
                onChange={handleCalcOptionChange}
                options={targetPriceOptions}
                placeholder="Select point type included in the calculation"
              />
            </div>
          </div>
          <div className="calculationHightlight">
            <div>{"*This filter helps identify rates matching your target lender pricing by calculating the current target price from the sum of "}
            {calcOptions.includes("lockpoint") && " lock point "} {calcOptions.includes("lockpoint") && (calcOptions.includes("adjustment") || calcOptions.includes("compensation")) && " , "} 
            {calcOptions.includes("adjustment") && " adjustment point "} {calcOptions.includes("adjustment") && calcOptions.includes("compensation") && " , "}
            {calcOptions.includes("compensation") && " compensation point "}</div>
          </div>
        </Col>
      </Row>
      {showMoreOptions && (
        <Row gutter={20}>
          <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}} >
          <Form.Group controlId="employment" className="text-left ">
            <Form.Label
              className="ratequoterFormLabels"
            >
              Employment
            </Form.Label>
            <Form.Control
              name="employment"
              as="select"
              size="sm"
              defaultValue={employment}
              onChange={handleChangeEmployment}
            >
              <option value="Employed">Employed</option>
              <option value="Selfemployed">Self-Employed</option>
              {/* <option value="Unemployed">Unemployed</option> */}
            </Form.Control>
          </Form.Group>
        </Col>
        {!(employment === "Unemployed") && <Col md={8}  style={{marginBottom:"0px",paddingRight:"10px"}} >
          <Form.Group controlId="incomeCondition" className="text-left ">
            <Form.Label
              className="ratequoterFormLabels"
            >
              Income
            </Form.Label>
            <Form.Control
              name="incomeCondition"
              as="select"
              size="sm"
              defaultValue={incomeCondition}
              onChange={(e) => {
                setIncomeCondition(e.target.value);
              }}
            >
              <option value="fullincome">Full income</option>
              <option value="partialincome">Partial income</option>
              {/* <option value="noincome">No income</option> */}
            </Form.Control>
          </Form.Group>
        </Col>}
       
        <Col md={8}  style={{marginBottom:"0px",paddingRight:"10px"}} >
          <Form.Group controlId="assets" className="text-left ">
            <Form.Label
              className="ratequoterFormLabels"
            >
              Impound
            </Form.Label>
            <Form.Control
              name="escrow"
              as="select"
              size="sm"
              defaultValue={escrowWaiver}
              onChange={(e) => {
                setEscrowWaiver(e.target.value);
              }}
            >
              <option value="false">Yes</option>
              <option value="true">No</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group className="text-left numericalInputWraper">
            <Form.Label className="ratequoterFormLabels">
              Second loan amount
            </Form.Label>
            <NumericalInput
              size="sm"
              value={secondMortageAmount}
              required
              onChange={(e) => setSecondMortgageAmount(e.target.value)}
              min={0}
              step={10000}
              noarrow={true}
            />
          </Form.Group>
        </Col>
        <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
            <Form.Group className="text-left">
              <Form.Label className="ratequoterFormLabels">
                Citizenship
              </Form.Label>
              <Form.Control
                size="sm"
                as="select"
                onChange={(e) => setCitizenship(e.target.value)}
                value={citizenship}
                required
              >
                <option value="US_CITIZENS">US Citizen</option>
                <option value="PERMANENT_RESIDENT_ALIEN">
                  Permanent Resident Alien
                </option>
                <option value="NON_RESIDENT_ALIEN">
                  Non Resident Alien
                </option>
              </Form.Control>
            </Form.Group>
          </Col>
          {(citizenship !== "US_CITIZENS" && citizenship !== "PERMANENT_RESIDENT_ALIEN") && (
            <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
              <Form.Group className="text-left ">
                <Form.Label className="ratequoterFormLabels">
                  Visa type
                </Form.Label>
                <Form.Control
                  size="sm"
                  as="select"
                  onChange={(e) => setVisaType(e.target.value)}
                  value={visaType}
                  required
                >
                  <option value="A_1"> A-1</option>
                  <option value="A_2"> A-2</option>
                  <option value="A_3"> A-3</option>
                  <option value="B_1"> B-1</option>
                  <option value="B_2"> B-2</option>
                  <option value="B_3"> B-3</option>
                  <option value="C_1"> C-1</option>
                  <option value="C_2"> C-2</option>
                  <option value="C_3"> C-3</option>
                  <option value="C_4"> C-4</option>
                  <option value="C_1D"> C-1D</option>
                  <option value="CP"> CP</option>
                  <option value="D_1"> D-1</option>
                  <option value="D_2"> D-2</option>
                  <option value="E_1"> E-1</option>
                  <option value="E_2"> E-2</option>
                  <option value="E_3"> E-3</option>
                  <option value="F_1"> F-1</option>
                  <option value="F_2"> F-2</option>
                  <option value="F_3"> F-3</option>
                  <option value="G_1"> G-1</option>
                  <option value="G_2"> G-2</option>
                  <option value="G_3"> G-3</option>
                  <option value="G_4"> G-4</option>
                  <option value="G_5"> G-5</option>
                  <option value="H_1A"> H-1A</option>
                  <option value="H_1B"> H-1B</option>
                  <option value="H_1B1"> H-1B1</option>
                  <option value="H_1C"> H-1C</option>
                  <option value="H_2"> H-2</option>
                  <option value="H_2A"> H-2A</option>
                  <option value="H_2B"> H-2B</option>
                  <option value="H_3"> H-3</option>
                  <option value="H_4"> H-4</option>
                  <option value="I"> I </option>
                  <option value="OR_1"> OR-1</option>
                  <option value="J_1"> J-1</option>
                  <option value="J_2"> J-2</option>
                  <option value="K_1"> K-1</option>
                  <option value="K_2"> K-2</option>
                  <option value="K_3"> K-3</option>
                  <option value="K_4"> K-4</option>
                  <option value="L_1"> L-1</option>
                  <option value="L_2"> L-2</option>
                  <option value="M_1"> M-1</option>
                  <option value="M_2"> M-2</option>
                  <option value="M_3"> M-3</option>
                  <option value="N_8"> N-8</option>
                  <option value="N_9"> N-9</option>
                  <option value="NACARA"> NACARA</option>
                  <option value="NATO_1_6"> NATO-1-6</option>
                  <option value="NATO_7"> NATO-7</option>
                  <option value="O_1"> O-1</option>
                  <option value="O_2"> O-2</option>
                  <option value="O_3"> O-3</option>
                  <option value="P_1"> P-1</option>
                  <option value="P_2"> P-2</option>
                  <option value="P_3"> P-3</option>
                  <option value="P_4"> P-4</option>
                  <option value="Q_1"> Q-1</option>
                  <option value="Q_2"> Q-2</option>
                  <option value="Q_3"> Q-3</option>
                  <option value="R_1"> R-1</option>
                  <option value="R_2"> R-2</option>
                  <option value="S_5"> S-5</option>
                  <option value="S_6"> S-6</option>
                  <option value="S_7"> S-7</option>
                  <option value="T_1"> T-1</option>
                  <option value="T_2"> T-2</option>
                  <option value="T_3"> T-3</option>
                  <option value="T_4"> T-4</option>
                  <option value="TD"> TD</option>
                  <option value="TN_1"> TN-1</option>
                  <option value="TN_2"> TN-2</option>
                  <option value="U_1"> U-1</option>
                  <option value="U_2"> U-2</option>
                  <option value="U_3"> U-3</option>
                  <option value="U_4"> U-4</option>
                  <option value="V_1"> V-1</option>
                  <option value="V_2"> V-2</option>
                  <option value="V_3"> V-3</option>
                </Form.Control>
              </Form.Group>
            </Col>
          )}

          <Col md={8} style={{marginBottom:"0px",paddingRight:"10px"}}>
          <Form.Group className="text-left numericalInputWraper">
            <Form.Label className="ratequoterFormLabels d-flex">
              Estimated closing fee
              <img style={{width: 15, height: 15, marginLeft: 6, cursor: 'pointer'}} src='/images/document-edit.svg' onClick={handleEditCostDetails}/>
            </Form.Label>
            {isCalculatedAtResults ? (
              <div className="form-control" style={{background: '#ECECEC', color: '#6E6E70', fontFamily: 'Inter', fontWeight: 400, height: 48, display: 'flex', alignItems: 'center'}}>
                <span style={{marginRight: 8}}>$</span>Calculated at results
              </div>
            ) : (
              <NumericalInput
                size="sm"
                value={isCalculatedAtResults ? 'Calculated at results' : estOtherCosts}
                required
                readOnly
                disabled
                onChange={(e) => {}}
                min={0}
                noarrow={true}
              />
            )}
            {isCalculatedAtResults && (
              <div style={{ color: '#6E6E70', fontFamily: 'Inter', fontSize: 12, lineHeight: 'normal', marginTop: 2 }}>
                *The estimate will be shown on the results page.
              </div>
            )}
          </Form.Group>
        </Col>
        </Row>
        
      )}
    
      <Row className="text-left">
          <Button style={{left: 0, paddingLeft: 0, color:"#325CEB",marginBottom: props.isMobile?"20px":""}}
            variant="rateQuoterAdvancedOptions"
            onClick={onMoreOptions}
            size="sm"
          >
            {showMoreOptions ? <>Less Options</> : <>Advanced Options</>}
            
          </Button>{" "}
      </Row>
      </div>
    </div>
  )}

  const updateResultFromFilter = () => {
    setNotmodified(false);
    props.search && getProducts();
  }

  const handleChangeSelectedlenders = (value) => {
    setSelectedLenders(value)
  }

  const tractInfo = <div className='tractInfoPreview w-100'>
    <div className="previewMSA">
        <div className='previewMSAInfo'>
            <div>MSA Code:</div>
            <div>{msaCode}</div>
        </div>
    </div>
    
    <hr />
    <div className='populationIncomeWrap'>
        <div className="previewPopulation">
            <div className='previewInfoWrap'>
                <div>Tract Income Level:</div> 
                {incomeIndicator === 1 && <div>Low Income Area</div>}
                {incomeIndicator === 2 &&<div>Moderate Income Area</div>}
                {incomeIndicator === 3 &&<div>Middle Income Area</div>}
                {incomeIndicator === 4 &&<div>Upper Income Area</div>}
            </div>
            <div className='previewInfoWrap'>
                <div>Tract Minority:</div>
                <div>{Math.floor(minority)}%</div>
            </div>

            <div className='previewInfoWrap'>
                <div>Total Population:</div>
                <div>{totalPopulation}</div>
            </div>
            <div className='previewInfoWrap'>
                <div>Hispanic Population:</div>
                <div>{hispanic} ({(100*hispanic/totalPopulation).toFixed(0)}%)</div>
            </div>
            <div className='previewInfoWrap'>
                <div>Black Population:</div>
                <div>{black} ({(100*black/totalPopulation).toFixed(0)}%)</div>
            </div>
            <div className='previewInfoWrap'>
                <div>Asian/Pacific Population:</div>
                <div>{asian+pacific} ({(100*(asian+pacific)/totalPopulation).toFixed(0)}%)</div>
            </div>
        </div>

        <div className='previewIncomeLimit'>
            <div className='previewInfoWrap'>
                <div>80% AMI:</div>
                <div>${com.commaize(0.8* medianIncome)}</div>
            </div>
            <div className='previewInfoWrap'>
                <div>100% AMI:</div>
                <div>${com.commaize(medianIncome)}</div>
            </div>
            <div className='previewInfoWrap'>
                <div>150% AMI:</div>
                <div>${com.commaize(1.5*medianIncome)}</div>
            </div>
            <div className='previewInfoWrap'>
                <div>80% MFI:</div>
                <div>${com.commaize(0.8* mfi)}</div>
            </div>
            <div className='previewInfoWrap'>
                <div>100% MFI:</div>
                <div>${com.commaize(mfi)}</div>
            </div>
            <div className='previewInfoWrap'>
                <div>150% MFI:</div>
                <div>${com.commaize(1.5* mfi)}</div>
            </div>
        </div>
    </div>
  </div>
  const closeLender = () => {
    setOpenLender(false)
  }
  const handleLenderDropdown = (flag) => {
    setOpenLender(flag)
  }
  const selectAll = (type) => {
    const isMyLenders = type === 'my'
    const selectedLendersForType = lenderData.filter(item => item.myLenders === isMyLenders).map(item => item.value)
    setSelectedLenders((prevSelected) => {
      const isAllSelected = selectedLendersForType.every(item => prevSelected.includes(item));
      if (isAllSelected) {
        return prevSelected.filter(item => !selectedLendersForType.includes(item))
      } else {
        return Array.from(new Set([...prevSelected, ...selectedLendersForType]))
      }
    })
  }
  const clearAll = () => {
    setSelectedLenders([])
  }
  const lenderDropdownContent = () => {
    return (
        <div className='document-lender-content' style={{width: 410}}>
            <div className='lender-title'>
                <span>Lenders</span>
                <div className='close-lender-box'><CloseOutlined className='close-lender' onClick={closeLender} /></div>
            </div>
            <div className="lender-select">
              <Checkbox.Group
                  className='filter-checkbox-group'
                  style={{
                      width: '100%',
                  }}
                  value={selectedLenders}
                  onChange={handleChangeSelectedlenders}
              >
                  <div style={{width: '100%'}}>
                      <div className="lender-select-item-title">
                        <div className="select-title">My lenders</div>
                        <div className="select-all" onClick={() => selectAll('my')}>Select all</div>
                      </div>
                      {
                        lenderData.filter(item => item.myLenders).map((item, index) => (
                            <div style={{height: 42, display: 'flex', alignItems: 'center'}} key={index}>
                                <Checkbox className="lender-checkbox" value={item.value}><span className='lender-checkbox-label'>{item.label}</span></Checkbox>
                            </div>
                        ))
                      }
                      {
                        lenderData.filter(item => !item.myLenders).length > 0 && (
                          <div style={{marginTop: 32}} className="lender-select-item-title">
                            <div className="select-title">
                              <span>Products from other lenders</span>
                              <div style={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 2}}>
                                <Tooltip trigger="click" placement="top" title="Explore competitive rates from Zeitro's partner lenders. Connect directly to learn more and get started.">
                                  <QuestionCircleOutlined style={{fontSize: 14, cursor: 'pointer'}}/>
                                </Tooltip>
                              </div>
                            </div>
                            <div className="select-all"  onClick={() => selectAll('other')}>Select all</div>
                          </div>
                        )
                      }
                      {
                        lenderData.filter(item => !item.myLenders).map((item, index) => (
                            <div style={{height: 42, display: 'flex', alignItems: 'center'}} key={index}>
                                <Checkbox className="lender-checkbox" value={item.value}><span className='lender-checkbox-label'>{item.label}</span></Checkbox>
                            </div>
                        ))
                      }
                  </div>
              </Checkbox.Group>
            </div>
            <div className='lender-action'>
              <div className='lender-clear' onClick={clearAll}>Clear</div>
            </div>
        </div>
    )
  }
  const maincolumns = [
    {
      title: 'Lender & Product',
      dataIndex: 'program',
      key: 'program',
      width:"150px",
      className: "outerRateColumn",
      render:(_,record)=>(<div>{_}</div>),
      sorter:(a, b) => a.program.localeCompare(b.program),
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: 'Rate/APR',
      dataIndex: 'rate',
      key: 'rate',
      width:"70px",
      className: "outerRateColumn",
      render:(_,record)=>(<div>{_}</div>),
      sorter:(a, b) => {
          return a.rate - b.rate;
      },
      sortDirections: ['ascend','descend',"ascend"],
    },
    {
      title: <Tooltip title="The adjusted price is calculated by adding the price adjustment points to the lock day price.">
        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* <img src="/images/rates-price-icon.svg"/>  */}
          <span>Price</span>
        </div>
      </Tooltip>,
      dataIndex: 'originalprice',
      key: 'originalprice',
      width:"130px",
      className: "outerRateColumn",
      render:(_,record)=>(<div>{_}</div>),
      sorter:(a, b) => a.originalprice - b.originalprice,
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: <Tooltip title='The compensation point established on the "Lenders" page.'>Comp.</Tooltip>,
      dataIndex: 'compensationprice',
      key: 'compensationprice',
      width:"110px",
      className: "outerRateColumn",
      render:(_,record)=>(<div>{_}</div>),
      sorter:(a, b) => a.compensationprice - b.compensationprice,
      sortDirections: ['descend','ascend','descend'],
    },

    {
      title: <Tooltip title='The total price is the sum of the lock day price, adjustment points, and compensation points.'>Final price</Tooltip>,
      dataIndex: 'points',
      key: 'points',
      width:"120px",
      className: "outerRateColumn",
      render:(_,record)=> (<div>{_}</div>),
      sorter:(a, b) => a.compensationprice - b.compensationprice,
      sortDirections: ['ascend','descend','ascend'],
    },
    {
      title: 'closing cost',
      dataIndex: 'monthlypay',
      key: 'monthlypay',
      width:"100px",
      className: "outerRateColumn",
      render:(_,record)=>(<div>{_}</div>),
      sorter:(a, b) => a.monthlypay - b.monthlypay,
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: 'PMT',
      dataIndex: 'monthlypay',
      key: 'monthlypay',
      width:"90px",
      className: "outerRateColumn",
      render:(_,record)=>(<div>{_}</div>),
      sorter:(a, b) => a.monthlypay - b.monthlypay,
      sortDirections: ['descend','ascend','descend'],
    },
  ]
  return (
    <div
      id="contain"
      ref={ref}
      style={{backgroundColor:"#ffffff",color: "black",justifyContent:"start", borderRadius: 12}}
      className="w-100 h-100 text-center"
    >
      <div className="w-100" style={{display: "none"}}>
        <div style={{ height: 68, border: 'none', borderBottom: '1px solid #DBDCDE' }} className="filterWraper">
          <div className="d-flex align-items-center h-100">
            <Select 
              className="eligibilitySelect"
              onChange={(e)=> onEligibilityViewChange(e)}
              value = {eligibilityView}
              options={[
                {value:"eligible",label:"Eligible"},
                {value:"ineligible",label:"Ineligible"}
              ]}
            />
            <div className={props.specificProgram==="GMCCCelebrities"?"gmccFilters d-flex":"filters d-flex"}>
              <Popconfirm
                overlayClassName="rate-popup-confirm"
                okText="Update"
                showCancel={false}
                onConfirm={updateResultFromFilter}
                icon={null}
                description={
                  <div style={{padding: 16}}>
                    <Slider
                      min={0}
                      max={1000000}
                      className="rate-popup-slider"
                      onChange={(value) => updateProperValue({target: { value }})}
                      value={emptyPropertyVal ? 0 : propertyValue}
                      tooltip={{
                        open: true,
                        formatter: (value) => {
                          return <div>${com.commaize(value)}</div>
                        },
                        getPopupContainer: (triggerNode) => triggerNode.parentNode,
                      }}
                    />
                  </div>
                }
              >
                <div style={{height: 44}} className="formInputOutline">
                  <div className="d-flex mr-2" style={{fontSize:"14px",whiteSpace:"nowrap"}}>Property value</div>
                  <div style={{backgroundColor:"FCFCFC", fontSize:"16px",marginRight:"2px"}}>$</div>
                  <div style={{fontSize:"16px"}}>{com.commaize(propertyValue)}</div>
                </div>
              </Popconfirm>
              <Popconfirm
                overlayClassName="rate-popup-confirm"
                okText="Update"
                showCancel={false}
                onConfirm={updateResultFromFilter}
                icon={null}
                description={
                  <div style={{padding: 16}}>
                    <Slider
                      min={0}
                      max={propertyValue - 1}
                      className="rate-popup-slider"
                      onChange={(value) => updateDownpayment({target: { value }})}
                      value={emptyDownpay ? 0 : downpayment}
                      tooltip={{
                        open: true,
                        formatter: (value) => {
                          return <div>${com.commaize(value)}</div>
                        },
                        getPopupContainer: (triggerNode) => triggerNode.parentNode,
                      }}
                    />
                  </div>
                }
              >
                <div style={{height: 44}} className="formInputOutline">
                  <div className="d-flex mr-2" style={{fontSize:"14px",whiteSpace:"nowrap"}}>{purpose == "Purchase" ? "Down payment" : "Loan amount"}</div>
                  <div style={{backgroundColor:"FCFCFC", fontSize:"16px"}}>$</div>
                  <div style={{fontSize:"16px"}}>{com.commaize(downpayment)}</div>
                </div>
              </Popconfirm>
              <div className="formInputOutline" style={{width: 172, height: 44}}>
                <div className="d-flex mr-2" style={{fontSize:"14px",whiteSpace:"nowrap"}}>Target price</div>
                <input type="number"  value={targetPricePoint} onChange={e=>setTargetPricePoint(e.target.value)} /> 
                {/* <div style={{backgroundColor:"FCFCFC", fontSize:"16px"}}>%</div> */}
              </div>
              <Select
                style={{
                  marginRight:"5px",
                  height: 44
                }}
                className="termSelectShortcut"
                onChange={(e)=> setLoanTerm(e)}
                value={loanTerm}
                options={[
                  {value:"fixed40",label:"Fixed 40 year"},
                  {value:"fixed30",label:"Fixed 30 year"},
                  {value:"fixed25",label:"Fixed 25 year"},
                  {value:"fixed20",label:"Fixed 20 year"},
                  {value:"fixed15",label:"Fixed 15 year"},
                  {value:"fixed10",label:"Fixed 10 year"},
                  {value:"arm5",label:"ARM 5 Year"},
                  {value:"arm7",label:"ARM 7 Year"},
                  {value:"arm10",label:"ARM 10 Year"}
                ]}
              />
              <Select 
                mode="multiple"
                style={{
                  marginRight:"5px",
                  height: 44,
                  minWidth: 180
                }}
                className="typeSelect"
                placeholder="Select types"
                value={productTypes}
                options={stdproducts}
                maxTagCount={1}
                maxTagPlaceholder={(values)=>`+${values.length}`}
                onChange={(e)=> setProductTypes(e)}
              />
              <Dropdown
                  trigger={['click']}
                  overlayClassName="filter-dropdown"
                  open={openLender}
                  dropdownRender={lenderDropdownContent}
                  placement="bottomRight"
                  onOpenChange={handleLenderDropdown}
              >
                  <div style={selectedLenders.length === 0 ? {paddingLeft: 0, backgroundColor: '#FFF'} : {}} className="rate-select-lender">
                    {
                      selectedLenders && selectedLenders.length > 0 ? (
                        <>
                          <div className="select-lender-text"><div>{selectedLenders[0]}</div>{selectedLenders.length > 1 && <span>+{selectedLenders.length - 1}</span>}</div>
                          <div className="select-lender-clear"><CloseOutlined style={{fontSize: 13}} onClick={clearAll} /></div>
                        </>
                      ) : (
                        <div>Select lenders</div>
                      )
                    }
                  </div>
              </Dropdown>
            </div>
          </div>
          <div className="rates-filter-btn" onClick={()=> setShowForm(true)}>
            <img src="/images/allfiltersIcon.png" style={{width:"24px", height:"24px"}}/>
            <span>All filters</span>
          </div>
        </div>
      </div>
      {notmodified? (<div>
          <div style={{justifyContent:"center", marginTop:props.isMobile?"20px":"300px", fontFamily: 'Inter', width: 324}}>
            <img src="/images/new-explorerates.svg"></img>
            <div style={{textAlign:"left", fontSize: 12, color: '#6E6E70',padding:"0px 32px 0px 32px", lineHeight: 'normal', letterSpacing: '0.2px', marginTop: 8}}>Adjust filters of borrower's information to explore rates and pricing.</div>
            <div className="d-flex justify-content-center"><Button className="rates-search-btn" onClick={()=> setShowForm(true)}>Search rates</Button></div>
          </div>
        </div>
      ):           
      loading ? (
        <div style={{
          width: '100%', 
          height: `calc(100vh - ${checkAccess([UR_PriceEngineUser]) ? 52 : 322}px)`, 
          padding: '20px 16px'
        }}>
          <Table
            className="outertable rates-page-table full-table rates-page-table-new"
            dataSource={[]}
            pagination={false}
            scroll={{ y: `calc(100vh - ${checkAccess([UR_PriceEngineUser]) ? 52 : 322}px - 80px)` }}
            locale={{
              emptyText: (
                <AutoProgress 
                    type="circle"
                    showInfo={false}
                    percent="auto"
                    strokeWidth={12} 
                    trailColor="#BDCBFB" 
                    strokeColor="#325CEB"
                    size={60}
                />
              ),
            }}
            columns={maincolumns}
          />
        </div>
      ) : 
      (Object.keys(allRates).length === 0 && !noProducts ? 
        // <div className="errorMessageWraper">
        //   <YellowWarning text="Unfortunately, this feature is currently unavailable. Please contact support@zeitro.com for assistance."/>
        // </div>
        <Table
          className="outertable rates-page-table full-table rates-page-table-new"
          dataSource={[]}
          pagination={false}
          scroll={{ y: `calc(100vh - ${checkAccess([UR_PriceEngineUser]) ? 52 : 322}px - 80px)` }}
          locale={{
            emptyText: 
              <div className="no-matched-product-found">
                <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none">
                  <path d="M26.0886 10.8796C28.3339 7.20679 33.6676 7.2068 35.9129 10.8796L55.5633 43.0232C57.9086 46.8598 55.1478 51.7837 50.6511 51.7839H11.3504C6.85376 51.7837 4.09289 46.8598 6.43825 43.0232L26.0886 10.8796ZM31.0027 39.4607C29.9442 39.4607 29.0361 39.7969 28.28 40.4695C27.5359 41.1418 27.1639 41.9508 27.1638 42.8962C27.1638 43.8628 27.5358 44.6827 28.28 45.3552C29.0361 46.0277 29.9442 46.364 31.0027 46.364C31.7005 46.3639 32.3342 46.2116 32.9041 45.907C33.4856 45.5918 33.9506 45.1715 34.2996 44.6462C34.6602 44.1208 34.8406 43.5372 34.8406 42.8962C34.8405 41.9507 34.4568 41.1419 33.6892 40.4695C32.9332 39.797 32.0378 39.4608 31.0027 39.4607ZM29.4568 17.0202C27.6746 17.0202 26.2851 18.5654 26.4734 20.3376L28.0037 34.74C28.1118 35.757 28.9692 36.529 29.992 36.529H32.0144C33.0363 36.529 33.8946 35.758 34.0037 34.7419L35.5496 20.3406C35.7398 18.5674 34.3505 17.0205 32.5672 17.0202H29.4568Z" fill="#CB8600"/>
                </svg>
                <div className="text-bold">{errorTitle}</div>
                <div className="text-normal">{errorMessage}</div>
              </div>
          }}
          columns={maincolumns}
        />
       :
        (
          (!notmodified) && noProducts ? 
            <div className="errorMessageWraper">
              <YellowWarning text={
                noArmProductsMessage(
                  props.searchParams?.pricingRequest?.loanTerm || props.searchParams?.loanTerm,
                  ineligibleProducts
                ) || "No qualified products."
              }/>
            </div> 
          :
          <>
          
          <div className={props.isMobile?"resultContainer-mobile":"resultContainer"} style={{height:"100%"}}>
            <AllRatesTable
            eligibleTabLabel="Eligibles"
            ineligibleTabLabel="Ineligibles"
            statsigSource="rates"
            errorTitle={errorTitle}
            errorMessage={errorMessage}
            searchParams={props.searchParams}
            loading={loading}
            downPayment={downpayment}
            isCelebrity={specificProgram==="GMCCCelebrities"}
            grantAvailable={checkGrantEligibility()}
            checkCelebrityLendingArea={checkCelebrityLendingArea()}
            resultlenderSet={resultlenderSet}
            connectedLendersMap={connectedLendersMap}
            selectedlenders={selectedLenders}
            loanTypeFilter={props.loanTypeFilter}
            allRates={allRates}
            formExtended={extended}
            stdproducts={productTypes}
            viewportH = {viewportHeight}
            borrowerPaidCompensationAmount={borrowerPaidCompensationAmount}
            loanInfo={{loanAmount: getLoanAmount(), occupancy: occupancy, purpose: purpose, propertyType: propertyType, fico:fico, ltv:getLtv(),escrow:escrowWaiver}}
            isMobile={isMobile}
            targetPrice={targetPricePoint}
            // setTargetPrice={setTargetPricePoint}
            targetRate={targetRate}
            targetOptions={calcOptions}
            loanterm={loanTerm}
            eligibilityView={eligibilityView}
            ineligibleProducts={ineligibleProducts}
            mobileHomeLenders={mobileHomeLenders}
            setShowForm={setShowForm}
            specialAdjustments={specialAdjustments}
            appliedClosingCostsDetail={appliedClosingCostsDetail}
          />
          </div>
          </>
        )
      )
      }

      <Modal
        className="lender-tip-modal"
        open={showAddLenderModal}
        onCancel={()=>setShowAddLendersModal(false)}
        footer={null}
        centered
      >
        <div className="lender-tip-modal-content">
          <div style={{color: '#222', fontSize: 20, fontWeight: 600, lineHeight: 'normal', marginBottom: 30}}>You haven't add any company-level lender setting into the system yet.</div>
          <div>
            {checkAccess([UR_Owner])?(
              <div className="d-flex" style={{flexDirection:"column", fontSize: 16, color: '#222', lineHeight: '20px'}}>
                You can see general rates right now, but for rates tailored to your lenders, update your lender settings in the Lenders section on the Management page.            </div>
            ):(
              <div className="d-flex" style={{fontSize: 16, color: '#222', lineHeight: '20px'}}>
                While you can always check general rates, for a more tailored view based on your lenders, your account admin can update settings in the Management page's Lenders section.            </div>
            )}
          </div>
        </div>

        <div className="lender-tip-modal-footer">
          {checkAccess([UR_Owner]) && <Button variant="link" className="lender-tip-modal-updateBtn" key="back" onClick={handleManagementDirect}>
            Update my lenders
          </Button>}
          <Button key="back" className="lender-tip-modal-ratesBtn" onClick={()=>setShowAddLendersModal(false)}>
            View general rates now
          </Button>
        </div>
      </Modal>

      {showReportIssues && (
        <ReportIssuesModal
          show={true}
          onHide={() => setShowReportIssues(false)}
        />
      )}

      {showEditCostDetails ? getEditCostsModal() : ""}
    </div>
  );
};
export default withRouter(RateQuoteLOVersion);
